/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import client, { clientInsightshub, clientPerformancePulse } from "client";
import { ENDPOINTS } from "./constant";

const backendResponse = [
  [
    {
      "heading": "Pro Plan\u2019s cat food sales growth trails Hills Science Diet due to declining distribution and lower repeat buying",
      "summary": "Pro Plan\u2019s dollar sales in cat food grew +2.56% to $147.7M, but Hills Science Diet outpaced with +4.34% to $169.4M. Hills\u2019 +6.39% TDP expansion and higher purchase frequency drove stronger growth, while Pro Plan\u2019s TDP fell -1.20% and repeat buying declined. Monitoring distribution and loyalty is critical to close the gap.",
      "insights": [
        "Dollars for PRO PLAN in CAT FOOD increased by +2.56% (from: 144,013,868.51, to: 147,705,718.82) from 2025-08-09 to 2025-11-08.",
        "Dollars for HILLS SCIENCE DIET in CAT FOOD increased by +4.34% (from: 162330556.71, to: 169377013.37) from 2025-08-09 to 2025-11-08.",
        "- Over the period from 2025-08-09 to 2025-11-08, PRO PLAN (Cat Food) saw Dollar Sales increase from $23,753,575.78 to $24,375,348.70, a +2.62% change, while HILLS SCIENCE DIET (Cat Food) experienced a stronger Dollar Sales growth from $29,835,092.32 to $30,977,815.58, a +3.83% change. This indicates the competitor outpaced PRO PLAN in sales growth within the same category and period.\n- During the same period, PRO PLAN's Total Distribution Points (TDP) declined from 370.06 to 365.62 (-1.20%), whereas HILLS SCIENCE DIET expanded its TDP from 364.17 to 387.45 (+6.39%). The competitor's significant distribution expansion might be the reason for its higher sales growth relative to PRO PLAN.\n- PRO PLAN maintained a stable Avg Unit Price per Pound at $6.06 (0.00% change) between 2025-08-09 and 2025-11-08, while HILLS SCIENCE DIET increased its price slightly from $5.44 to $5.47 (+0.55%). Despite the competitor's price increase, its sales and distribution also grew, suggesting price was not a limiting factor for its performance in this period.\n- From 2025-06-14 to 2025-09-06, PRO PLAN's Average Household Penetration rose from 1.43 to 1.50 (+0.07), while HILLS SCIENCE DIET increased from 1.52 to 1.56 (+0.04). Both brands gained penetration, but PRO PLAN's increase was marginally higher, indicating a slightly stronger ability to attract new households in this period.\n- PRO PLAN's Purchase Frequency decreased from 5.43 to 5.31 (-0.12) between 2025-06-14 and 2025-09-06, while HILLS SCIENCE DIET saw a small increase from 4.89 to 4.93 (+0.04). This suggests PRO PLAN buyers purchased less frequently, potentially impacting overall buy rate and loyalty, while competitor buyers increased frequency.\n- Value per Buying Household for PRO PLAN dropped from $156.53 to $152.12 (-$4.41) over the same period, while HILLS SCIENCE DIET also declined from $165.88 to $163.60 (-$2.28). Both brands saw reduced spend per household, but the decrease was more pronounced for PRO PLAN, possibly reflecting lower purchase frequency or basket size.\n- In consumer sentiment, PRO PLAN's Average Rating improved slightly from 4.54 to 4.56 (+0.02) between 2025-08-16 and 2025-11-15, while HILLS SCIENCE DIET saw a larger increase from 4.12 to 4.19 (+0.07). The competitor made greater gains in consumer ratings, which might be the reason for its stronger sales and distribution performance.\n- PRO PLAN's Reviews Volume was nearly flat, declining marginally from 10,339 to 10,326 (-0.13%) in the same period, while HILLS SCIENCE DIET experienced a sharp drop from 6,273 to 4,386 (-30.08%). Despite the competitor's rating improvement, its review volume decreased substantially, which might be the reason for less consumer engagement or reduced marketing activity.\n- Average Sentiments for PRO PLAN improved from 0.52 to 0.54 (+0.02), while HILLS SCIENCE DIET increased from 0.37 to 0.40 (+0.03) between 2025-08-16 and 2025-11-15. Both brands saw sentiment gains, but PRO PLAN maintained a higher sentiment score overall, which might be the reason for its stable consumer perception despite less sales growth.\n- Across the analyzed periods, PRO PLAN's performance was characterized by stable pricing, slight gains in household penetration, and improved consumer sentiment, but offset by declining purchase frequency and lower value per buying household. In contrast, HILLS SCIENCE DIET achieved higher sales growth, expanded distribution, and improved ratings, suggesting a more effective market expansion strategy during these periods.\n- The competitor's simultaneous increase in price, distribution, and sales volume, coupled with improved consumer ratings, highlights a multidimensional performance advantage over PRO PLAN for Cat Food in the latest periods. However, PRO PLAN's higher household penetration gain and sentiment score indicate underlying strengths in consumer reach and perception.\n- No additional context from df1 or df2 was available to reinforce or contradict these shifts; all insights are strictly based on the provided metric values and change magnitudes within the specified dimensions and time frames."
      ],
      "priority": "High",
      "time_period": {
        "panel": {
          "start_period": "14 Jun 2025",
          "end_period": "6 Sep 2025"
        },
        "reviews": {
          "start_period": "16 Aug 2025",
          "end_period": "15 Nov 2025"
        },
        "sales": {
          "start_period": "9 Aug 2025",
          "end_period": "8 Nov 2025"
        }
      },
      "consolidated_insight": [
        "Pro Plan\u2019s dollar sales in cat food **increased by +2.56% **(from: $144.01M, to: $147.71M), but Hills Science Diet achieved a **stronger +4.34% growth** (from: $162.33M, to: $169.38M), highlighting a competitive gap in revenue momentum.",
        "Within the same category, Pro Plan\u2019s **dollar sales rose +2.62%** (from: $23.75M, to: $24.38M), while Hills Science Diet posted a **higher +3.83% increase **(from: $29.84M, to: $30.98M), confirming Hills\u2019 superior sales acceleration.",
        "Pro Plan\u2019s **total distribution points (TDP) declined -1.20%** (from: 370.06, to: 365.62), whereas Hills Science Diet **expanded TDP by +6.39% **(from: 364.17, to: 387.45). This significant distribution expansion by Hills might be the reason for its higher sales growth relative to Pro Plan.",
        "Pro Plan maintained a **stable avg unit price per pound at $6.06** (0.00% change), while Hills Science Diet **increased price slightly by +0.55%** (from: $5.44, to: $5.47). Despite the competitor\u2019s price increase, its sales and distribution also grew, suggesting price was not a limiting factor for performance.",
        "Pro Plan\u2019s **average household penetration rose +0.07 points** (from: 1.43, to: 1.50), marginally outpacing Hills Science Diet\u2019s **+0.04 point increase** (from: 1.52, to: 1.56), indicating Pro Plan\u2019s slightly stronger new household acquisition.",
        "**Purchase frequency** for Pro Plan **declined -0.12** (from: 5.43, to: 5.31), while Hills Science Diet saw a **small increase of +0.04** (from: 4.89, to: 4.93). This suggests Pro Plan buyers purchased less frequently, potentially impacting overall buy rate and loyalty, while competitor buyers increased frequency.",
        "**Value per buying household** for Pro Plan **dropped -$4.41** (from: $156.53, to: $152.12), while Hills Science Diet also **declined -$2.28** (from: $165.88, to: $163.60). Both brands saw reduced spend per household, but the decrease was more pronounced for Pro Plan, possibly reflecting lower purchase frequency or basket size.",
        "In consumer sentiment, Pro Plan\u2019s **average rating** improved **slightly by +0.02** (from: 4.54, to: 4.56), while Hills Science Diet saw a larger increase of **+0.07** (from: 4.12, to: 4.19). The competitor made greater gains in consumer ratings, which might be the reason for its stronger sales and distribution performance.",
        "Pro Plan\u2019s **review volume** was nearly flat, declining marginally by **-0.13%** (from: 10,339, to: 10,326), while Hills Science Diet experienced a **sharp drop of -30.08%** (from: 6,273, to: 4,386). Despite Hills\u2019 rating improvement, its review volume decreased substantially, which might be the reason for less consumer engagement or reduced marketing activity.",
        "**Average sentiment** for Pro Plan **improved by +0.02** (from: 0.52, to: 0.54), while Hills Science Diet **increased by +0.03** (from: 0.37, to: 0.40). Both brands saw sentiment gains, but Pro Plan maintained a higher sentiment score overall, which might be the reason for its stable consumer perception despite less sales growth.",
        "Across the analyzed periods, Pro Plan\u2019s performance was characterized by **stable pricing, slight gains in household penetration, and improved consumer sentiment**, but offset by **declining purchase frequency and lower value per buying household**. In contrast, Hills Science Diet achieved **higher sales growth, expanded distribution, and improved ratings**, suggesting a more effective market expansion strategy during these periods."
      ],
      "base_metric": "Dollars",
      "topic": "Sales Performance",
      "data_visualization": [
        {
          "data": [
            {
              "line": {
                "color": "#a287e6",
                "width": 3
              },
              "marker": {
                "line": {
                  "color": "white",
                  "width": 1
                },
                "size": 9
              },
              "mode": "lines+markers",
              "name": "hills science diet - cat food",
              "x": [
                "2024-02-03T00:00:00",
                "2024-03-02T00:00:00",
                "2024-03-30T00:00:00",
                "2024-04-27T00:00:00",
                "2024-05-25T00:00:00",
                "2024-06-22T00:00:00",
                "2024-07-20T00:00:00",
                "2024-08-17T00:00:00",
                "2024-09-14T00:00:00",
                "2024-10-12T00:00:00",
                "2024-11-09T00:00:00",
                "2024-12-07T00:00:00",
                "2025-01-04T00:00:00",
                "2025-02-01T00:00:00",
                "2025-03-01T00:00:00",
                "2025-03-29T00:00:00",
                "2025-04-26T00:00:00",
                "2025-05-24T00:00:00",
                "2025-06-21T00:00:00",
                "2025-07-19T00:00:00",
                "2025-08-16T00:00:00",
                "2025-09-13T00:00:00",
                "2025-10-11T00:00:00",
                "2025-11-08T00:00:00"
              ],
              "y": {
                "dtype": "f8",
                "bdata": "ke18P7XMc0A+6Nms+v9yQEIc6+I2GXNAKH6MuWsYc0DwFkhQ/AdzQPa52op993JANaK0N/jBc0CdPCzUWohzQLBQa5o3HHRA0bNZ9bnMdUDIuriNhjZ1QBe30QAe8nVAsAPnjGgddUAfY+5awhZ1QPMf0m8f13VAgp7Nqs+TdUBGA3gLJE92QFg5tMh2qXZAeXqlLENVdkAoDwu15l13QPp+ary0yXZAMlUwKim7d0C3Yn/ZPXh4QG+BBMWPrnhA"
              },
              "type": "scatter"
            },
            {
              "line": {
                "color": "#222222",
                "width": 3
              },
              "marker": {
                "line": {
                  "color": "white",
                  "width": 1
                },
                "size": 9
              },
              "mode": "lines+markers",
              "name": "pro plan - cat food",
              "x": [
                "2024-02-03T00:00:00",
                "2024-03-02T00:00:00",
                "2024-03-30T00:00:00",
                "2024-04-27T00:00:00",
                "2024-05-25T00:00:00",
                "2024-06-22T00:00:00",
                "2024-07-20T00:00:00",
                "2024-08-17T00:00:00",
                "2024-09-14T00:00:00",
                "2024-10-12T00:00:00",
                "2024-11-09T00:00:00",
                "2024-12-07T00:00:00",
                "2025-01-04T00:00:00",
                "2025-02-01T00:00:00",
                "2025-03-01T00:00:00",
                "2025-03-29T00:00:00",
                "2025-04-26T00:00:00",
                "2025-05-24T00:00:00",
                "2025-06-21T00:00:00",
                "2025-07-19T00:00:00",
                "2025-08-16T00:00:00",
                "2025-09-13T00:00:00",
                "2025-10-11T00:00:00",
                "2025-11-08T00:00:00"
              ],
              "y": {
                "dtype": "f8",
                "bdata": "vOMUHYmyckASNjy90gp0QG/whcmUoXJA4qWbxCBNc0BHlPYGnwFzQElQ/Bhz5nJALNSa5p1UdEAJrBxaZCx0QGHD0ysl53RAomez6nNndkDFjzF3bWt1QKjGSzdJ4HZAqRPQRJjxdEDOqs/VFnF1QJQ6AU1EuXVAWOwvu2eedUBu5/upsXh2QDKZKhhVzXZAcoqO5HIAd0DAyqFFtrx3QG6jAbyFunZAIf32deCTdkD4Meau5Qd3QNbFbTTA7XZA"
              },
              "type": "scatter"
            }
          ],
          "layout": {
            "template": {
              "data": {
                "histogram2dcontour": [
                  {
                    "type": "histogram2dcontour",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "choropleth": [
                  {
                    "type": "choropleth",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "histogram2d": [
                  {
                    "type": "histogram2d",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "heatmap": [
                  {
                    "type": "heatmap",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "contourcarpet": [
                  {
                    "type": "contourcarpet",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "contour": [
                  {
                    "type": "contour",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "surface": [
                  {
                    "type": "surface",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "mesh3d": [
                  {
                    "type": "mesh3d",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "scatter": [
                  {
                    "fillpattern": {
                      "fillmode": "overlay",
                      "size": 10,
                      "solidity": 0.2
                    },
                    "type": "scatter"
                  }
                ],
                "parcoords": [
                  {
                    "type": "parcoords",
                    "line": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterpolargl": [
                  {
                    "type": "scatterpolargl",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "bar": [
                  {
                    "error_x": {
                      "color": "#2a3f5f"
                    },
                    "error_y": {
                      "color": "#2a3f5f"
                    },
                    "marker": {
                      "line": {
                        "color": "#E5ECF6",
                        "width": 0.5
                      },
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "bar"
                  }
                ],
                "scattergeo": [
                  {
                    "type": "scattergeo",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterpolar": [
                  {
                    "type": "scatterpolar",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "histogram": [
                  {
                    "marker": {
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "histogram"
                  }
                ],
                "scattergl": [
                  {
                    "type": "scattergl",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatter3d": [
                  {
                    "type": "scatter3d",
                    "line": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    },
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattermap": [
                  {
                    "type": "scattermap",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattermapbox": [
                  {
                    "type": "scattermapbox",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterternary": [
                  {
                    "type": "scatterternary",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattercarpet": [
                  {
                    "type": "scattercarpet",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "carpet": [
                  {
                    "aaxis": {
                      "endlinecolor": "#2a3f5f",
                      "gridcolor": "white",
                      "linecolor": "white",
                      "minorgridcolor": "white",
                      "startlinecolor": "#2a3f5f"
                    },
                    "baxis": {
                      "endlinecolor": "#2a3f5f",
                      "gridcolor": "white",
                      "linecolor": "white",
                      "minorgridcolor": "white",
                      "startlinecolor": "#2a3f5f"
                    },
                    "type": "carpet"
                  }
                ],
                "table": [
                  {
                    "cells": {
                      "fill": {
                        "color": "#EBF0F8"
                      },
                      "line": {
                        "color": "white"
                      }
                    },
                    "header": {
                      "fill": {
                        "color": "#C8D4E3"
                      },
                      "line": {
                        "color": "white"
                      }
                    },
                    "type": "table"
                  }
                ],
                "barpolar": [
                  {
                    "marker": {
                      "line": {
                        "color": "#E5ECF6",
                        "width": 0.5
                      },
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "barpolar"
                  }
                ],
                "pie": [
                  {
                    "automargin": true,
                    "type": "pie"
                  }
                ]
              },
              "layout": {
                "autotypenumbers": "strict",
                "colorway": [
                  "#636efa",
                  "#EF553B",
                  "#00cc96",
                  "#ab63fa",
                  "#FFA15A",
                  "#19d3f3",
                  "#FF6692",
                  "#B6E880",
                  "#FF97FF",
                  "#FECB52"
                ],
                "font": {
                  "color": "#2a3f5f"
                },
                "hovermode": "closest",
                "hoverlabel": {
                  "align": "left"
                },
                "paper_bgcolor": "white",
                "plot_bgcolor": "#E5ECF6",
                "polar": {
                  "bgcolor": "#E5ECF6",
                  "angularaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "radialaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  }
                },
                "ternary": {
                  "bgcolor": "#E5ECF6",
                  "aaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "baxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "caxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  }
                },
                "coloraxis": {
                  "colorbar": {
                    "outlinewidth": 0,
                    "ticks": ""
                  }
                },
                "colorscale": {
                  "sequential": [
                    [
                      0.0,
                      "#0d0887"
                    ],
                    [
                      0.1111111111111111,
                      "#46039f"
                    ],
                    [
                      0.2222222222222222,
                      "#7201a8"
                    ],
                    [
                      0.3333333333333333,
                      "#9c179e"
                    ],
                    [
                      0.4444444444444444,
                      "#bd3786"
                    ],
                    [
                      0.5555555555555556,
                      "#d8576b"
                    ],
                    [
                      0.6666666666666666,
                      "#ed7953"
                    ],
                    [
                      0.7777777777777778,
                      "#fb9f3a"
                    ],
                    [
                      0.8888888888888888,
                      "#fdca26"
                    ],
                    [
                      1.0,
                      "#f0f921"
                    ]
                  ],
                  "sequentialminus": [
                    [
                      0.0,
                      "#0d0887"
                    ],
                    [
                      0.1111111111111111,
                      "#46039f"
                    ],
                    [
                      0.2222222222222222,
                      "#7201a8"
                    ],
                    [
                      0.3333333333333333,
                      "#9c179e"
                    ],
                    [
                      0.4444444444444444,
                      "#bd3786"
                    ],
                    [
                      0.5555555555555556,
                      "#d8576b"
                    ],
                    [
                      0.6666666666666666,
                      "#ed7953"
                    ],
                    [
                      0.7777777777777778,
                      "#fb9f3a"
                    ],
                    [
                      0.8888888888888888,
                      "#fdca26"
                    ],
                    [
                      1.0,
                      "#f0f921"
                    ]
                  ],
                  "diverging": [
                    [
                      0,
                      "#8e0152"
                    ],
                    [
                      0.1,
                      "#c51b7d"
                    ],
                    [
                      0.2,
                      "#de77ae"
                    ],
                    [
                      0.3,
                      "#f1b6da"
                    ],
                    [
                      0.4,
                      "#fde0ef"
                    ],
                    [
                      0.5,
                      "#f7f7f7"
                    ],
                    [
                      0.6,
                      "#e6f5d0"
                    ],
                    [
                      0.7,
                      "#b8e186"
                    ],
                    [
                      0.8,
                      "#7fbc41"
                    ],
                    [
                      0.9,
                      "#4d9221"
                    ],
                    [
                      1,
                      "#276419"
                    ]
                  ]
                },
                "xaxis": {
                  "gridcolor": "white",
                  "linecolor": "white",
                  "ticks": "",
                  "title": {
                    "standoff": 15
                  },
                  "zerolinecolor": "white",
                  "automargin": true,
                  "zerolinewidth": 2
                },
                "yaxis": {
                  "gridcolor": "white",
                  "linecolor": "white",
                  "ticks": "",
                  "title": {
                    "standoff": 15
                  },
                  "zerolinecolor": "white",
                  "automargin": true,
                  "zerolinewidth": 2
                },
                "scene": {
                  "xaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  },
                  "yaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  },
                  "zaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  }
                },
                "shapedefaults": {
                  "line": {
                    "color": "#2a3f5f"
                  }
                },
                "annotationdefaults": {
                  "arrowcolor": "#2a3f5f",
                  "arrowhead": 0,
                  "arrowwidth": 1
                },
                "geo": {
                  "bgcolor": "white",
                  "landcolor": "#E5ECF6",
                  "subunitcolor": "white",
                  "showland": true,
                  "showlakes": true,
                  "lakecolor": "white"
                },
                "title": {
                  "x": 0.05
                },
                "mapbox": {
                  "style": "light"
                }
              }
            },
            "title": {
              "font": {
                "size": 16,
                "family": "Trebuchet MS, sans-serif",
                "color": "#363636"
              },
              "text": "Hills Science Diet-Cat Food Vs Pro Plan-Cat Food (Total Distribution points (TDP))",
              "x": 0.5
            },
            "legend": {
              "font": {
                "size": 15
              },
              "orientation": "h",
              "yanchor": "top",
              "y": -0.29,
              "xanchor": "center",
              "x": 0.5,
              "bgcolor": "rgba(0,0,0,0)",
              "borderwidth": 0
            },
            "xaxis": {
              "title": {
                "font": {
                  "size": 16
                },
                "text": ""
              },
              "tickfont": {
                "size": 13
              },
              "showgrid": true,
              "gridcolor": "#e5ecf6",
              "gridwidth": 1,
              "zeroline": false,
              "tickformat": "%d %b %Y",
              "tickangle": -45,
              "ticks": "outside"
            },
            "yaxis": {
              "title": {
                "font": {
                  "size": 16
                },
                "text": "Total Distribution points (TDP)"
              },
              "tickfont": {
                "size": 13
              },
              "showgrid": true,
              "gridcolor": "#e5ecf6",
              "gridwidth": 1,
              "zeroline": false
            },
            "margin": {
              "l": 40,
              "r": 40,
              "t": 80,
              "b": 120
            },
            "font": {
              "family": "Trebuchet MS, sans-serif",
              "size": 13
            },
            "plot_bgcolor": "#ffffff"
          }
        },
        {
          "data": [
            {
              "line": {
                "color": "#a287e6",
                "width": 3
              },
              "marker": {
                "line": {
                  "color": "white",
                  "width": 1
                },
                "size": 9
              },
              "mode": "lines+markers",
              "name": "hills science diet - cat food",
              "x": [
                "2021-10-09T00:00:00",
                "2022-01-01T00:00:00",
                "2022-03-26T00:00:00",
                "2022-06-18T00:00:00",
                "2022-09-10T00:00:00",
                "2022-12-03T00:00:00",
                "2023-02-25T00:00:00",
                "2023-05-20T00:00:00",
                "2023-08-12T00:00:00",
                "2023-11-04T00:00:00",
                "2024-01-27T00:00:00",
                "2024-04-20T00:00:00",
                "2024-07-13T00:00:00",
                "2024-10-05T00:00:00",
                "2024-12-28T00:00:00",
                "2025-03-22T00:00:00",
                "2025-06-14T00:00:00",
                "2025-09-06T00:00:00"
              ],
              "y": {
                "dtype": "f8",
                "bdata": "AAAAAADwWUAIrBxaZLNaQKrx0k1imFtAlkOLbOfjXEC0yHa+n/JdQMUgsHJo+V1AMzMzMzMzX0AX2c73UwtgQGDl0CLbtWBAVg4tsp0DYUC+nxov3ZBhQF66SQwCH2JAarx0kxgwYkDjpZvEIBRjQPCnxks3wWNAd76fGi/tY0AAAAAAALxkQKwcWmQ7c2RA"
              },
              "type": "scatter"
            },
            {
              "line": {
                "color": "#222222",
                "width": 3
              },
              "marker": {
                "line": {
                  "color": "white",
                  "width": 1
                },
                "size": 9
              },
              "mode": "lines+markers",
              "name": "pro plan - cat food",
              "x": [
                "2021-10-09T00:00:00",
                "2022-01-01T00:00:00",
                "2022-03-26T00:00:00",
                "2022-06-18T00:00:00",
                "2022-09-10T00:00:00",
                "2022-12-03T00:00:00",
                "2023-02-25T00:00:00",
                "2023-05-20T00:00:00",
                "2023-08-12T00:00:00",
                "2023-11-04T00:00:00",
                "2024-01-27T00:00:00",
                "2024-04-20T00:00:00",
                "2024-07-13T00:00:00",
                "2024-10-05T00:00:00",
                "2024-12-28T00:00:00",
                "2025-03-22T00:00:00",
                "2025-06-14T00:00:00",
                "2025-09-06T00:00:00"
              ],
              "y": {
                "dtype": "f8",
                "bdata": "001iEFhhXkDb+X5qvFReQJZDi2zn215AJQaBlUN3YED8qfHSTYZgQAIrhxbZqmFAAAAAAADUYkC0yHa+nypjQP7UeOkmkWRAexSuR+FuZUD8qfHSTWZmQMHKoUW2m2dAmpmZmZnRZkBMN4lBYKVkQH0/NV66MWNAF9nO91N3Y0CiRbbz/ZBjQIcW2c73A2NA"
              },
              "type": "scatter"
            }
          ],
          "layout": {
            "template": {
              "data": {
                "histogram2dcontour": [
                  {
                    "type": "histogram2dcontour",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "choropleth": [
                  {
                    "type": "choropleth",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "histogram2d": [
                  {
                    "type": "histogram2d",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "heatmap": [
                  {
                    "type": "heatmap",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "contourcarpet": [
                  {
                    "type": "contourcarpet",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "contour": [
                  {
                    "type": "contour",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "surface": [
                  {
                    "type": "surface",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "mesh3d": [
                  {
                    "type": "mesh3d",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "scatter": [
                  {
                    "fillpattern": {
                      "fillmode": "overlay",
                      "size": 10,
                      "solidity": 0.2
                    },
                    "type": "scatter"
                  }
                ],
                "parcoords": [
                  {
                    "type": "parcoords",
                    "line": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterpolargl": [
                  {
                    "type": "scatterpolargl",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "bar": [
                  {
                    "error_x": {
                      "color": "#2a3f5f"
                    },
                    "error_y": {
                      "color": "#2a3f5f"
                    },
                    "marker": {
                      "line": {
                        "color": "#E5ECF6",
                        "width": 0.5
                      },
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "bar"
                  }
                ],
                "scattergeo": [
                  {
                    "type": "scattergeo",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterpolar": [
                  {
                    "type": "scatterpolar",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "histogram": [
                  {
                    "marker": {
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "histogram"
                  }
                ],
                "scattergl": [
                  {
                    "type": "scattergl",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatter3d": [
                  {
                    "type": "scatter3d",
                    "line": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    },
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattermap": [
                  {
                    "type": "scattermap",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattermapbox": [
                  {
                    "type": "scattermapbox",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterternary": [
                  {
                    "type": "scatterternary",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattercarpet": [
                  {
                    "type": "scattercarpet",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "carpet": [
                  {
                    "aaxis": {
                      "endlinecolor": "#2a3f5f",
                      "gridcolor": "white",
                      "linecolor": "white",
                      "minorgridcolor": "white",
                      "startlinecolor": "#2a3f5f"
                    },
                    "baxis": {
                      "endlinecolor": "#2a3f5f",
                      "gridcolor": "white",
                      "linecolor": "white",
                      "minorgridcolor": "white",
                      "startlinecolor": "#2a3f5f"
                    },
                    "type": "carpet"
                  }
                ],
                "table": [
                  {
                    "cells": {
                      "fill": {
                        "color": "#EBF0F8"
                      },
                      "line": {
                        "color": "white"
                      }
                    },
                    "header": {
                      "fill": {
                        "color": "#C8D4E3"
                      },
                      "line": {
                        "color": "white"
                      }
                    },
                    "type": "table"
                  }
                ],
                "barpolar": [
                  {
                    "marker": {
                      "line": {
                        "color": "#E5ECF6",
                        "width": 0.5
                      },
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "barpolar"
                  }
                ],
                "pie": [
                  {
                    "automargin": true,
                    "type": "pie"
                  }
                ]
              },
              "layout": {
                "autotypenumbers": "strict",
                "colorway": [
                  "#636efa",
                  "#EF553B",
                  "#00cc96",
                  "#ab63fa",
                  "#FFA15A",
                  "#19d3f3",
                  "#FF6692",
                  "#B6E880",
                  "#FF97FF",
                  "#FECB52"
                ],
                "font": {
                  "color": "#2a3f5f"
                },
                "hovermode": "closest",
                "hoverlabel": {
                  "align": "left"
                },
                "paper_bgcolor": "white",
                "plot_bgcolor": "#E5ECF6",
                "polar": {
                  "bgcolor": "#E5ECF6",
                  "angularaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "radialaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  }
                },
                "ternary": {
                  "bgcolor": "#E5ECF6",
                  "aaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "baxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "caxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  }
                },
                "coloraxis": {
                  "colorbar": {
                    "outlinewidth": 0,
                    "ticks": ""
                  }
                },
                "colorscale": {
                  "sequential": [
                    [
                      0.0,
                      "#0d0887"
                    ],
                    [
                      0.1111111111111111,
                      "#46039f"
                    ],
                    [
                      0.2222222222222222,
                      "#7201a8"
                    ],
                    [
                      0.3333333333333333,
                      "#9c179e"
                    ],
                    [
                      0.4444444444444444,
                      "#bd3786"
                    ],
                    [
                      0.5555555555555556,
                      "#d8576b"
                    ],
                    [
                      0.6666666666666666,
                      "#ed7953"
                    ],
                    [
                      0.7777777777777778,
                      "#fb9f3a"
                    ],
                    [
                      0.8888888888888888,
                      "#fdca26"
                    ],
                    [
                      1.0,
                      "#f0f921"
                    ]
                  ],
                  "sequentialminus": [
                    [
                      0.0,
                      "#0d0887"
                    ],
                    [
                      0.1111111111111111,
                      "#46039f"
                    ],
                    [
                      0.2222222222222222,
                      "#7201a8"
                    ],
                    [
                      0.3333333333333333,
                      "#9c179e"
                    ],
                    [
                      0.4444444444444444,
                      "#bd3786"
                    ],
                    [
                      0.5555555555555556,
                      "#d8576b"
                    ],
                    [
                      0.6666666666666666,
                      "#ed7953"
                    ],
                    [
                      0.7777777777777778,
                      "#fb9f3a"
                    ],
                    [
                      0.8888888888888888,
                      "#fdca26"
                    ],
                    [
                      1.0,
                      "#f0f921"
                    ]
                  ],
                  "diverging": [
                    [
                      0,
                      "#8e0152"
                    ],
                    [
                      0.1,
                      "#c51b7d"
                    ],
                    [
                      0.2,
                      "#de77ae"
                    ],
                    [
                      0.3,
                      "#f1b6da"
                    ],
                    [
                      0.4,
                      "#fde0ef"
                    ],
                    [
                      0.5,
                      "#f7f7f7"
                    ],
                    [
                      0.6,
                      "#e6f5d0"
                    ],
                    [
                      0.7,
                      "#b8e186"
                    ],
                    [
                      0.8,
                      "#7fbc41"
                    ],
                    [
                      0.9,
                      "#4d9221"
                    ],
                    [
                      1,
                      "#276419"
                    ]
                  ]
                },
                "xaxis": {
                  "gridcolor": "white",
                  "linecolor": "white",
                  "ticks": "",
                  "title": {
                    "standoff": 15
                  },
                  "zerolinecolor": "white",
                  "automargin": true,
                  "zerolinewidth": 2
                },
                "yaxis": {
                  "gridcolor": "white",
                  "linecolor": "white",
                  "ticks": "",
                  "title": {
                    "standoff": 15
                  },
                  "zerolinecolor": "white",
                  "automargin": true,
                  "zerolinewidth": 2
                },
                "scene": {
                  "xaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  },
                  "yaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  },
                  "zaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  }
                },
                "shapedefaults": {
                  "line": {
                    "color": "#2a3f5f"
                  }
                },
                "annotationdefaults": {
                  "arrowcolor": "#2a3f5f",
                  "arrowhead": 0,
                  "arrowwidth": 1
                },
                "geo": {
                  "bgcolor": "white",
                  "landcolor": "#E5ECF6",
                  "subunitcolor": "white",
                  "showland": true,
                  "showlakes": true,
                  "lakecolor": "white"
                },
                "title": {
                  "x": 0.05
                },
                "mapbox": {
                  "style": "light"
                }
              }
            },
            "title": {
              "font": {
                "size": 16,
                "family": "Trebuchet MS, sans-serif",
                "color": "#363636"
              },
              "text": "Hills Science Diet-Cat Food Vs Pro Plan-Cat Food (Value per buying household)",
              "x": 0.5
            },
            "legend": {
              "font": {
                "size": 15
              },
              "orientation": "h",
              "yanchor": "top",
              "y": -0.29,
              "xanchor": "center",
              "x": 0.5,
              "bgcolor": "rgba(0,0,0,0)",
              "borderwidth": 0
            },
            "xaxis": {
              "title": {
                "font": {
                  "size": 16
                },
                "text": ""
              },
              "tickfont": {
                "size": 13
              },
              "showgrid": true,
              "gridcolor": "#e5ecf6",
              "gridwidth": 1,
              "zeroline": false,
              "tickformat": "%d %b %Y",
              "tickangle": -45,
              "ticks": "outside"
            },
            "yaxis": {
              "title": {
                "font": {
                  "size": 16
                },
                "text": "Value per buying household"
              },
              "tickfont": {
                "size": 13
              },
              "showgrid": true,
              "gridcolor": "#e5ecf6",
              "gridwidth": 1,
              "zeroline": false
            },
            "margin": {
              "l": 40,
              "r": 40,
              "t": 80,
              "b": 120
            },
            "font": {
              "family": "Trebuchet MS, sans-serif",
              "size": 13
            },
            "plot_bgcolor": "#ffffff"
          }
        }
      ]
    },
    {
      heading: "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      summary:
        "**Pro Plan’s** repeat buyer rate and distribution both declined, undermining loyalty despite stronger household penetration growth than **Hills Science Diet**. Meanwhile, **Hills Science Diet** expanded distribution and improved purchase frequency, highlighting a growing competitive gap in cat food retention and reach.",
      insights: [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2",
      ],
      priority: "High",
      time_period: {
        'sales': {
          'start_period': '9 Aug 2025',
          'end_period': '8 Nov 2025'
        },
        'reviews': { 'start_period': '16 Aug 2025', 'end_period': '15 Nov 2025' },
        'panel': { 'start_period': '14 Jun 2025', 'end_period': '6 Sep 2025' }
      },
      consolidated_insight: ['**Pro Plan’s 2+ time buying households** declined **-2.49 points** (from: 73.8, to: 71.31), a sharper drop than **Hills Science Diet’s** **-0.57 points** (from: 71.63, to: 71.06), signaling a significant erosion in repeat buyer loyalty for Pro Plan, which is critical for long-term brand health.',
        '**Purchase frequency** for **Pro Plan** dropped **-0.12** (from: 5.43, to: 5.31), while **Hills Science Diet** improved **+0.04** (from: 4.89, to: 4.93), indicating Pro Plan is losing momentum with existing buyers, possibly due to operational or competitive pressures.',
        '**Total Distribution Points (TDP)** for **Pro Plan** declined **-1.20%** (from: 370.06, to: 365.62), while **Hills Science Diet** expanded **+6.39%** (from: 364.17, to: 387.45), suggesting that Hills’ increased shelf presence might be the reason for its improved buyer retention and engagement metrics.',
        '**Household penetration** increased more for **Pro Plan** (**+0.07 points**, from: 1.43, to: 1.50) than for **Hills Science Diet** (**+0.04 points**, from: 1.52, to: 1.56), confirming Pro Plan’s strength in new buyer acquisition, but this is being offset by weaker repeat buying and distribution.',
        '**Buying households** for **Pro Plan** rose **+85,949** (from: 1.85M, to: 1.94M), outpacing **Hills Science Diet’s** **+53,217** (from: 1.96M, to: 2.01M), yet Pro Plan’s inability to retain these buyers is limiting the impact of this acquisition.',
        '**Avg price per pound** for **Pro Plan** remained flat (**$6.06**), while **Hills Science Diet** increased slightly (**+0.55%**, from: $5.44, to: $5.47). Pro Plan’s stable pricing, despite declining distribution and loyalty, may not be enough to counteract competitive pressures.',
        'In **ratings and reviews**, **Pro Plan’s average rating** improved marginally (**+0.02**, from: 4.54, to: 4.56), and **average sentiment** rose (**+0.02**, from: 0.52, to: 0.54), maintaining a higher sentiment than **Hills Science Diet** (**+0.03**, from: 0.37, to: 0.40). However, **Hills Science Diet’s** rating improved more (**+0.07**, from: 4.12, to: 4.19), suggesting it is closing the gap in perceived quality. **Review volume** for Pro Plan was stable (**-0.13%**, from: 10,339, to: 10,326), while Hills Science Diet saw a sharp drop (**-30.08%**, from: 6,273, to: 4,386), indicating lower engagement or a shift in focus, but Pro Plan’s higher sentiment and stable engagement are not translating into improved loyalty.',
        'Overall, **Pro Plan’s** declining repeat purchase metrics and shrinking distribution, despite stronger acquisition and positive consumer sentiment, highlight a widening performance gap versus **Hills Science Diet**, which is leveraging expanded distribution and stable loyalty to strengthen its position in cat food.'],
      base_metric: "Rating",
      topic: "Consumer_rating",
      created_at: "2025-10-17T09:15:00Z",
      data_visualization: [
        {
          "data": [
            {
              "line": {
                "color": "#a287e6",
                "width": 3
              },
              "marker": {
                "line": {
                  "color": "white",
                  "width": 1
                },
                "size": 9
              },
              "mode": "lines+markers",
              "name": "pro plan - cat food",
              "x": [
                "2021-10-09T00:00:00",
                "2022-01-01T00:00:00",
                "2022-03-26T00:00:00",
                "2022-06-18T00:00:00",
                "2022-09-10T00:00:00",
                "2022-12-03T00:00:00",
                "2023-02-25T00:00:00",
                "2023-05-20T00:00:00",
                "2023-08-12T00:00:00",
                "2023-11-04T00:00:00",
                "2024-01-27T00:00:00",
                "2024-04-20T00:00:00",
                "2024-07-13T00:00:00",
                "2024-10-05T00:00:00",
                "2024-12-28T00:00:00",
                "2025-03-22T00:00:00",
                "2025-06-14T00:00:00",
                "2025-09-06T00:00:00"
              ],
              "y": {
                "dtype": "f8",
                "bdata": "vHSTGATWQkAlBoGVQ3tCQDeJQWDlYEFAZDvfT43XQEBI4XoUrsc\u002fQGDl0CLbWT9ApHA9CtdDP0BmZmZmZuY+QPLSTWIQOEBAZmZmZmaWQECe76fGSxdBQDMzMzMzo0FAeekmMQgcQUA730+Nl+4+QIXrUbgeBT1Ay6FFtvNdPUDP91PjpVs8QP7UeOkm8TpA"
              },
              "type": "scatter"
            },
            {
              "line": {
                "color": "#222222",
                "width": 3
              },
              "marker": {
                "line": {
                  "color": "white",
                  "width": 1
                },
                "size": 9
              },
              "mode": "lines+markers",
              "name": "purina one - cat food",
              "x": [
                "2021-10-09T00:00:00",
                "2022-01-01T00:00:00",
                "2022-03-26T00:00:00",
                "2022-06-18T00:00:00",
                "2022-09-10T00:00:00",
                "2022-12-03T00:00:00",
                "2023-02-25T00:00:00",
                "2023-05-20T00:00:00",
                "2023-08-12T00:00:00",
                "2023-11-04T00:00:00",
                "2024-01-27T00:00:00",
                "2024-04-20T00:00:00",
                "2024-07-13T00:00:00",
                "2024-10-05T00:00:00",
                "2024-12-28T00:00:00",
                "2025-03-22T00:00:00",
                "2025-06-14T00:00:00",
                "2025-09-06T00:00:00"
              ],
              "y": {
                "dtype": "f8",
                "bdata": "rBxaZDt\u002fO0DFILByaLE7QK5H4XoUTjtA9P3UeOlmO0BeukkMAis7QPp+arx0cztA46WbxCAwPEB\u002farx0k\u002fg9QMHKoUW2Mz9Ad76fGi9dQEDsUbgehVtAQDm0yHa+z0BA\u002fKnx0k1CQEBWDi2ynS9AQLgehetRmD9Ad76fGi8dP0D0\u002fdR46eY+QMuhRbbzfT5A"
              },
              "type": "scatter"
            }
          ],
          "layout": {
            "template": {
              "data": {
                "histogram2dcontour": [
                  {
                    "type": "histogram2dcontour",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "choropleth": [
                  {
                    "type": "choropleth",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "histogram2d": [
                  {
                    "type": "histogram2d",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "heatmap": [
                  {
                    "type": "heatmap",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "contourcarpet": [
                  {
                    "type": "contourcarpet",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "contour": [
                  {
                    "type": "contour",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "surface": [
                  {
                    "type": "surface",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "mesh3d": [
                  {
                    "type": "mesh3d",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "scatter": [
                  {
                    "fillpattern": {
                      "fillmode": "overlay",
                      "size": 10,
                      "solidity": 0.2
                    },
                    "type": "scatter"
                  }
                ],
                "parcoords": [
                  {
                    "type": "parcoords",
                    "line": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterpolargl": [
                  {
                    "type": "scatterpolargl",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "bar": [
                  {
                    "error_x": {
                      "color": "#2a3f5f"
                    },
                    "error_y": {
                      "color": "#2a3f5f"
                    },
                    "marker": {
                      "line": {
                        "color": "#E5ECF6",
                        "width": 0.5
                      },
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "bar"
                  }
                ],
                "scattergeo": [
                  {
                    "type": "scattergeo",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterpolar": [
                  {
                    "type": "scatterpolar",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "histogram": [
                  {
                    "marker": {
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "histogram"
                  }
                ],
                "scattergl": [
                  {
                    "type": "scattergl",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatter3d": [
                  {
                    "type": "scatter3d",
                    "line": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    },
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattermap": [
                  {
                    "type": "scattermap",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattermapbox": [
                  {
                    "type": "scattermapbox",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterternary": [
                  {
                    "type": "scatterternary",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattercarpet": [
                  {
                    "type": "scattercarpet",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "carpet": [
                  {
                    "aaxis": {
                      "endlinecolor": "#2a3f5f",
                      "gridcolor": "white",
                      "linecolor": "white",
                      "minorgridcolor": "white",
                      "startlinecolor": "#2a3f5f"
                    },
                    "baxis": {
                      "endlinecolor": "#2a3f5f",
                      "gridcolor": "white",
                      "linecolor": "white",
                      "minorgridcolor": "white",
                      "startlinecolor": "#2a3f5f"
                    },
                    "type": "carpet"
                  }
                ],
                "table": [
                  {
                    "cells": {
                      "fill": {
                        "color": "#EBF0F8"
                      },
                      "line": {
                        "color": "white"
                      }
                    },
                    "header": {
                      "fill": {
                        "color": "#C8D4E3"
                      },
                      "line": {
                        "color": "white"
                      }
                    },
                    "type": "table"
                  }
                ],
                "barpolar": [
                  {
                    "marker": {
                      "line": {
                        "color": "#E5ECF6",
                        "width": 0.5
                      },
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "barpolar"
                  }
                ],
                "pie": [
                  {
                    "automargin": true,
                    "type": "pie"
                  }
                ]
              },
              "layout": {
                "autotypenumbers": "strict",
                "colorway": [
                  "#636efa",
                  "#EF553B",
                  "#00cc96",
                  "#ab63fa",
                  "#FFA15A",
                  "#19d3f3",
                  "#FF6692",
                  "#B6E880",
                  "#FF97FF",
                  "#FECB52"
                ],
                "font": {
                  "color": "#2a3f5f"
                },
                "hovermode": "closest",
                "hoverlabel": {
                  "align": "left"
                },
                "paper_bgcolor": "white",
                "plot_bgcolor": "#E5ECF6",
                "polar": {
                  "bgcolor": "#E5ECF6",
                  "angularaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "radialaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  }
                },
                "ternary": {
                  "bgcolor": "#E5ECF6",
                  "aaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "baxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "caxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  }
                },
                "coloraxis": {
                  "colorbar": {
                    "outlinewidth": 0,
                    "ticks": ""
                  }
                },
                "colorscale": {
                  "sequential": [
                    [
                      0.0,
                      "#0d0887"
                    ],
                    [
                      0.1111111111111111,
                      "#46039f"
                    ],
                    [
                      0.2222222222222222,
                      "#7201a8"
                    ],
                    [
                      0.3333333333333333,
                      "#9c179e"
                    ],
                    [
                      0.4444444444444444,
                      "#bd3786"
                    ],
                    [
                      0.5555555555555556,
                      "#d8576b"
                    ],
                    [
                      0.6666666666666666,
                      "#ed7953"
                    ],
                    [
                      0.7777777777777778,
                      "#fb9f3a"
                    ],
                    [
                      0.8888888888888888,
                      "#fdca26"
                    ],
                    [
                      1.0,
                      "#f0f921"
                    ]
                  ],
                  "sequentialminus": [
                    [
                      0.0,
                      "#0d0887"
                    ],
                    [
                      0.1111111111111111,
                      "#46039f"
                    ],
                    [
                      0.2222222222222222,
                      "#7201a8"
                    ],
                    [
                      0.3333333333333333,
                      "#9c179e"
                    ],
                    [
                      0.4444444444444444,
                      "#bd3786"
                    ],
                    [
                      0.5555555555555556,
                      "#d8576b"
                    ],
                    [
                      0.6666666666666666,
                      "#ed7953"
                    ],
                    [
                      0.7777777777777778,
                      "#fb9f3a"
                    ],
                    [
                      0.8888888888888888,
                      "#fdca26"
                    ],
                    [
                      1.0,
                      "#f0f921"
                    ]
                  ],
                  "diverging": [
                    [
                      0,
                      "#8e0152"
                    ],
                    [
                      0.1,
                      "#c51b7d"
                    ],
                    [
                      0.2,
                      "#de77ae"
                    ],
                    [
                      0.3,
                      "#f1b6da"
                    ],
                    [
                      0.4,
                      "#fde0ef"
                    ],
                    [
                      0.5,
                      "#f7f7f7"
                    ],
                    [
                      0.6,
                      "#e6f5d0"
                    ],
                    [
                      0.7,
                      "#b8e186"
                    ],
                    [
                      0.8,
                      "#7fbc41"
                    ],
                    [
                      0.9,
                      "#4d9221"
                    ],
                    [
                      1,
                      "#276419"
                    ]
                  ]
                },
                "xaxis": {
                  "gridcolor": "white",
                  "linecolor": "white",
                  "ticks": "",
                  "title": {
                    "standoff": 15
                  },
                  "zerolinecolor": "white",
                  "automargin": true,
                  "zerolinewidth": 2
                },
                "yaxis": {
                  "gridcolor": "white",
                  "linecolor": "white",
                  "ticks": "",
                  "title": {
                    "standoff": 15
                  },
                  "zerolinecolor": "white",
                  "automargin": true,
                  "zerolinewidth": 2
                },
                "scene": {
                  "xaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  },
                  "yaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  },
                  "zaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  }
                },
                "shapedefaults": {
                  "line": {
                    "color": "#2a3f5f"
                  }
                },
                "annotationdefaults": {
                  "arrowcolor": "#2a3f5f",
                  "arrowhead": 0,
                  "arrowwidth": 1
                },
                "geo": {
                  "bgcolor": "white",
                  "landcolor": "#E5ECF6",
                  "subunitcolor": "white",
                  "showland": true,
                  "showlakes": true,
                  "lakecolor": "white"
                },
                "title": {
                  "x": 0.05
                },
                "mapbox": {
                  "style": "light"
                }
              }
            },
            "title": {
              "font": {
                "size": 16,
                "family": "Trebuchet MS, sans-serif",
                "color": "#363636"
              },
              "text": "Pro Plan-Cat Food Vs Purina One-Cat Food (volume per buying household)",
              "x": 0.5
            },
            "legend": {
              "font": {
                "size": 15
              },
              "orientation": "h",
              "yanchor": "top",
              "y": -0.29,
              "xanchor": "center",
              "x": 0.5,
              "bgcolor": "rgba(0,0,0,0)",
              "borderwidth": 0
            },
            "xaxis": {
              "title": {
                "font": {
                  "size": 16
                },
                "text": ""
              },
              "tickfont": {
                "size": 13
              },
              "showgrid": true,
              "gridcolor": "#e5ecf6",
              "gridwidth": 1,
              "zeroline": false,
              "tickformat": "%d %b %Y",
              "tickangle": -45,
              "ticks": "outside"
            },
            "yaxis": {
              "title": {
                "font": {
                  "size": 16
                },
                "text": "volume per buying household"
              },
              "tickfont": {
                "size": 13
              },
              "showgrid": true,
              "gridcolor": "#e5ecf6",
              "gridwidth": 1,
              "zeroline": false
            },
            "margin": {
              "l": 40,
              "r": 40,
              "t": 80,
              "b": 120
            },
            "font": {
              "family": "Trebuchet MS, sans-serif",
              "size": 13
            },
            "plot_bgcolor": "#ffffff"
          }
        },
        {
          "data": [
            {
              "line": {
                "color": "#a287e6",
                "width": 3
              },
              "marker": {
                "line": {
                  "color": "white",
                  "width": 1
                },
                "size": 9
              },
              "mode": "lines+markers",
              "name": "pro plan - cat food",
              "x": [
                "2021-10-09T00:00:00",
                "2022-01-01T00:00:00",
                "2022-03-26T00:00:00",
                "2022-06-18T00:00:00",
                "2022-09-10T00:00:00",
                "2022-12-03T00:00:00",
                "2023-02-25T00:00:00",
                "2023-05-20T00:00:00",
                "2023-08-12T00:00:00",
                "2023-11-04T00:00:00",
                "2024-01-27T00:00:00",
                "2024-04-20T00:00:00",
                "2024-07-13T00:00:00",
                "2024-10-05T00:00:00",
                "2024-12-28T00:00:00",
                "2025-03-22T00:00:00",
                "2025-06-14T00:00:00",
                "2025-09-06T00:00:00"
              ],
              "y": {
                "dtype": "f8",
                "bdata": "vHSTGATWQkAlBoGVQ3tCQDeJQWDlYEFAZDvfT43XQEBI4XoUrsc\u002fQGDl0CLbWT9ApHA9CtdDP0BmZmZmZuY+QPLSTWIQOEBAZmZmZmaWQECe76fGSxdBQDMzMzMzo0FAeekmMQgcQUA730+Nl+4+QIXrUbgeBT1Ay6FFtvNdPUDP91PjpVs8QP7UeOkm8TpA"
              },
              "type": "scatter"
            },
            {
              "line": {
                "color": "#222222",
                "width": 3
              },
              "marker": {
                "line": {
                  "color": "white",
                  "width": 1
                },
                "size": 9
              },
              "mode": "lines+markers",
              "name": "purina one - cat food",
              "x": [
                "2021-10-09T00:00:00",
                "2022-01-01T00:00:00",
                "2022-03-26T00:00:00",
                "2022-06-18T00:00:00",
                "2022-09-10T00:00:00",
                "2022-12-03T00:00:00",
                "2023-02-25T00:00:00",
                "2023-05-20T00:00:00",
                "2023-08-12T00:00:00",
                "2023-11-04T00:00:00",
                "2024-01-27T00:00:00",
                "2024-04-20T00:00:00",
                "2024-07-13T00:00:00",
                "2024-10-05T00:00:00",
                "2024-12-28T00:00:00",
                "2025-03-22T00:00:00",
                "2025-06-14T00:00:00",
                "2025-09-06T00:00:00"
              ],
              "y": {
                "dtype": "f8",
                "bdata": "rBxaZDt\u002fO0DFILByaLE7QK5H4XoUTjtA9P3UeOlmO0BeukkMAis7QPp+arx0cztA46WbxCAwPEB\u002farx0k\u002fg9QMHKoUW2Mz9Ad76fGi9dQEDsUbgehVtAQDm0yHa+z0BA\u002fKnx0k1CQEBWDi2ynS9AQLgehetRmD9Ad76fGi8dP0D0\u002fdR46eY+QMuhRbbzfT5A"
              },
              "type": "scatter"
            }
          ],
          "layout": {
            "template": {
              "data": {
                "histogram2dcontour": [
                  {
                    "type": "histogram2dcontour",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "choropleth": [
                  {
                    "type": "choropleth",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "histogram2d": [
                  {
                    "type": "histogram2d",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "heatmap": [
                  {
                    "type": "heatmap",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "contourcarpet": [
                  {
                    "type": "contourcarpet",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "contour": [
                  {
                    "type": "contour",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "surface": [
                  {
                    "type": "surface",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    },
                    "colorscale": [
                      [
                        0.0,
                        "#0d0887"
                      ],
                      [
                        0.1111111111111111,
                        "#46039f"
                      ],
                      [
                        0.2222222222222222,
                        "#7201a8"
                      ],
                      [
                        0.3333333333333333,
                        "#9c179e"
                      ],
                      [
                        0.4444444444444444,
                        "#bd3786"
                      ],
                      [
                        0.5555555555555556,
                        "#d8576b"
                      ],
                      [
                        0.6666666666666666,
                        "#ed7953"
                      ],
                      [
                        0.7777777777777778,
                        "#fb9f3a"
                      ],
                      [
                        0.8888888888888888,
                        "#fdca26"
                      ],
                      [
                        1.0,
                        "#f0f921"
                      ]
                    ]
                  }
                ],
                "mesh3d": [
                  {
                    "type": "mesh3d",
                    "colorbar": {
                      "outlinewidth": 0,
                      "ticks": ""
                    }
                  }
                ],
                "scatter": [
                  {
                    "fillpattern": {
                      "fillmode": "overlay",
                      "size": 10,
                      "solidity": 0.2
                    },
                    "type": "scatter"
                  }
                ],
                "parcoords": [
                  {
                    "type": "parcoords",
                    "line": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterpolargl": [
                  {
                    "type": "scatterpolargl",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "bar": [
                  {
                    "error_x": {
                      "color": "#2a3f5f"
                    },
                    "error_y": {
                      "color": "#2a3f5f"
                    },
                    "marker": {
                      "line": {
                        "color": "#E5ECF6",
                        "width": 0.5
                      },
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "bar"
                  }
                ],
                "scattergeo": [
                  {
                    "type": "scattergeo",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterpolar": [
                  {
                    "type": "scatterpolar",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "histogram": [
                  {
                    "marker": {
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "histogram"
                  }
                ],
                "scattergl": [
                  {
                    "type": "scattergl",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatter3d": [
                  {
                    "type": "scatter3d",
                    "line": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    },
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattermap": [
                  {
                    "type": "scattermap",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattermapbox": [
                  {
                    "type": "scattermapbox",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scatterternary": [
                  {
                    "type": "scatterternary",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "scattercarpet": [
                  {
                    "type": "scattercarpet",
                    "marker": {
                      "colorbar": {
                        "outlinewidth": 0,
                        "ticks": ""
                      }
                    }
                  }
                ],
                "carpet": [
                  {
                    "aaxis": {
                      "endlinecolor": "#2a3f5f",
                      "gridcolor": "white",
                      "linecolor": "white",
                      "minorgridcolor": "white",
                      "startlinecolor": "#2a3f5f"
                    },
                    "baxis": {
                      "endlinecolor": "#2a3f5f",
                      "gridcolor": "white",
                      "linecolor": "white",
                      "minorgridcolor": "white",
                      "startlinecolor": "#2a3f5f"
                    },
                    "type": "carpet"
                  }
                ],
                "table": [
                  {
                    "cells": {
                      "fill": {
                        "color": "#EBF0F8"
                      },
                      "line": {
                        "color": "white"
                      }
                    },
                    "header": {
                      "fill": {
                        "color": "#C8D4E3"
                      },
                      "line": {
                        "color": "white"
                      }
                    },
                    "type": "table"
                  }
                ],
                "barpolar": [
                  {
                    "marker": {
                      "line": {
                        "color": "#E5ECF6",
                        "width": 0.5
                      },
                      "pattern": {
                        "fillmode": "overlay",
                        "size": 10,
                        "solidity": 0.2
                      }
                    },
                    "type": "barpolar"
                  }
                ],
                "pie": [
                  {
                    "automargin": true,
                    "type": "pie"
                  }
                ]
              },
              "layout": {
                "autotypenumbers": "strict",
                "colorway": [
                  "#636efa",
                  "#EF553B",
                  "#00cc96",
                  "#ab63fa",
                  "#FFA15A",
                  "#19d3f3",
                  "#FF6692",
                  "#B6E880",
                  "#FF97FF",
                  "#FECB52"
                ],
                "font": {
                  "color": "#2a3f5f"
                },
                "hovermode": "closest",
                "hoverlabel": {
                  "align": "left"
                },
                "paper_bgcolor": "white",
                "plot_bgcolor": "#E5ECF6",
                "polar": {
                  "bgcolor": "#E5ECF6",
                  "angularaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "radialaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  }
                },
                "ternary": {
                  "bgcolor": "#E5ECF6",
                  "aaxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "baxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  },
                  "caxis": {
                    "gridcolor": "white",
                    "linecolor": "white",
                    "ticks": ""
                  }
                },
                "coloraxis": {
                  "colorbar": {
                    "outlinewidth": 0,
                    "ticks": ""
                  }
                },
                "colorscale": {
                  "sequential": [
                    [
                      0.0,
                      "#0d0887"
                    ],
                    [
                      0.1111111111111111,
                      "#46039f"
                    ],
                    [
                      0.2222222222222222,
                      "#7201a8"
                    ],
                    [
                      0.3333333333333333,
                      "#9c179e"
                    ],
                    [
                      0.4444444444444444,
                      "#bd3786"
                    ],
                    [
                      0.5555555555555556,
                      "#d8576b"
                    ],
                    [
                      0.6666666666666666,
                      "#ed7953"
                    ],
                    [
                      0.7777777777777778,
                      "#fb9f3a"
                    ],
                    [
                      0.8888888888888888,
                      "#fdca26"
                    ],
                    [
                      1.0,
                      "#f0f921"
                    ]
                  ],
                  "sequentialminus": [
                    [
                      0.0,
                      "#0d0887"
                    ],
                    [
                      0.1111111111111111,
                      "#46039f"
                    ],
                    [
                      0.2222222222222222,
                      "#7201a8"
                    ],
                    [
                      0.3333333333333333,
                      "#9c179e"
                    ],
                    [
                      0.4444444444444444,
                      "#bd3786"
                    ],
                    [
                      0.5555555555555556,
                      "#d8576b"
                    ],
                    [
                      0.6666666666666666,
                      "#ed7953"
                    ],
                    [
                      0.7777777777777778,
                      "#fb9f3a"
                    ],
                    [
                      0.8888888888888888,
                      "#fdca26"
                    ],
                    [
                      1.0,
                      "#f0f921"
                    ]
                  ],
                  "diverging": [
                    [
                      0,
                      "#8e0152"
                    ],
                    [
                      0.1,
                      "#c51b7d"
                    ],
                    [
                      0.2,
                      "#de77ae"
                    ],
                    [
                      0.3,
                      "#f1b6da"
                    ],
                    [
                      0.4,
                      "#fde0ef"
                    ],
                    [
                      0.5,
                      "#f7f7f7"
                    ],
                    [
                      0.6,
                      "#e6f5d0"
                    ],
                    [
                      0.7,
                      "#b8e186"
                    ],
                    [
                      0.8,
                      "#7fbc41"
                    ],
                    [
                      0.9,
                      "#4d9221"
                    ],
                    [
                      1,
                      "#276419"
                    ]
                  ]
                },
                "xaxis": {
                  "gridcolor": "white",
                  "linecolor": "white",
                  "ticks": "",
                  "title": {
                    "standoff": 15
                  },
                  "zerolinecolor": "white",
                  "automargin": true,
                  "zerolinewidth": 2
                },
                "yaxis": {
                  "gridcolor": "white",
                  "linecolor": "white",
                  "ticks": "",
                  "title": {
                    "standoff": 15
                  },
                  "zerolinecolor": "white",
                  "automargin": true,
                  "zerolinewidth": 2
                },
                "scene": {
                  "xaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  },
                  "yaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  },
                  "zaxis": {
                    "backgroundcolor": "#E5ECF6",
                    "gridcolor": "white",
                    "linecolor": "white",
                    "showbackground": true,
                    "ticks": "",
                    "zerolinecolor": "white",
                    "gridwidth": 2
                  }
                },
                "shapedefaults": {
                  "line": {
                    "color": "#2a3f5f"
                  }
                },
                "annotationdefaults": {
                  "arrowcolor": "#2a3f5f",
                  "arrowhead": 0,
                  "arrowwidth": 1
                },
                "geo": {
                  "bgcolor": "white",
                  "landcolor": "#E5ECF6",
                  "subunitcolor": "white",
                  "showland": true,
                  "showlakes": true,
                  "lakecolor": "white"
                },
                "title": {
                  "x": 0.05
                },
                "mapbox": {
                  "style": "light"
                }
              }
            },
            "title": {
              "font": {
                "size": 16,
                "family": "Trebuchet MS, sans-serif",
                "color": "#363636"
              },
              "text": "Pro Plan-Cat Food Vs Purina One-Cat Food (volume per buying household)",
              "x": 0.5
            },
            "legend": {
              "font": {
                "size": 15
              },
              "orientation": "h",
              "yanchor": "top",
              "y": -0.29,
              "xanchor": "center",
              "x": 0.5,
              "bgcolor": "rgba(0,0,0,0)",
              "borderwidth": 0
            },
            "xaxis": {
              "title": {
                "font": {
                  "size": 16
                },
                "text": ""
              },
              "tickfont": {
                "size": 13
              },
              "showgrid": true,
              "gridcolor": "#e5ecf6",
              "gridwidth": 1,
              "zeroline": false,
              "tickformat": "%d %b %Y",
              "tickangle": -45,
              "ticks": "outside"
            },
            "yaxis": {
              "title": {
                "font": {
                  "size": 16
                },
                "text": "volume per buying household"
              },
              "tickfont": {
                "size": 13
              },
              "showgrid": true,
              "gridcolor": "#e5ecf6",
              "gridwidth": 1,
              "zeroline": false
            },
            "margin": {
              "l": 40,
              "r": 40,
              "t": 80,
              "b": 120
            },
            "font": {
              "family": "Trebuchet MS, sans-serif",
              "size": 13
            },
            "plot_bgcolor": "#ffffff"
          }
        }],
      chartType: 'line',
    }, {
      heading: "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      summary:
        "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      insights: [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2",
      ],
      priority: "High",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      base_metric: "Rating",
      topic: "Consumer_rating",
      created_at: "2025-10-17T08:45:00Z",
    },
    {
      heading: "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      summary:
        "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      insights: [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2",
      ],
      priority: "High",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      base_metric: "Rating",
      topic: "Consumer_rating",
      created_at: "2025-10-16T14:15:00Z",
    },
    {
      heading: "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      summary:
        "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      insights: [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2",
      ],
      priority: "High",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      base_metric: "Rating",
      topic: "Consumer_rating",
      created_at: "2025-10-05T16:30:00Z",
    },
    {
      heading: "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      summary:
        "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      insights: [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2",
      ],
      priority: "High",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      base_metric: "Rating",
      topic: "Consumer_rating",
      created_at: "2025-10-14T11:00:00Z",
    },
    {
      heading: "Purina Improves Packaging Experience Among Pet Owners",
      summary:
        "Purina's new packaging design has resulted in improved storage satisfaction and handling experience among pet owners.",
      insights: [
        "Packaging satisfaction increased by 20%",
        "User feedback highlights ease of use and reseal design as top improvements",
      ],
      priority: "Medium",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        ["Packaging design improvements contributed to higher customer satisfaction and better usability.", "Packaging design improvements contributed to higher customer satisfaction and better usability."],
      base_metric: "Packaging",
      topic: "Product_experience",
      created_at: "2025-10-13T09:30:00Z",
    },
    {
      heading: "Iams Shows Surge in Nutritional Value Recognition",
      summary:
        "Iams has gained significant recognition for its improved nutritional formulation compared to competitors.",
      insights: [
        "Nutritional value rating increased by 0.25 points",
        "Positive feedback from both consumers and critics regarding formulation quality",
      ],
      priority: "Low",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        "Iams’ nutritional upgrades boosted perception and consumer trust in brand health quality.",
      base_metric: "Nutritional_value",
      topic: "Product_quality",
      created_at: "2025-10-12T10:15:00Z",
    },
    {
      heading: "Iams Shows Surge in Nutritional Value Recognition",
      summary:
        "Iams has gained significant recognition for its improved nutritional formulation compared to competitors.",
      insights: [
        "Nutritional value rating increased by 0.25 points",
        "Positive feedback from both consumers and critics regarding formulation quality",
      ],
      priority: "Low",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        "Iams’ nutritional upgrades boosted perception and consumer trust in brand health quality.",
      base_metric: "Nutritional_value",
      topic: "Product_quality",
      created_at: "2025-10-12T10:15:00Z",
    },
    {
      heading: "Iams Shows Surge in Nutritional Value Recognition",
      summary:
        "Iams has gained significant recognition for its improved nutritional formulation compared to competitors.",
      insights: [
        "Nutritional value rating increased by 0.25 points",
        "Positive feedback from both consumers and critics regarding formulation quality",
      ],
      priority: "Low",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        "Iams’ nutritional upgrades boosted perception and consumer trust in brand health quality.",
      base_metric: "Nutritional_value",
      topic: "Product_quality",
      created_at: "2025-10-12T10:15:00Z",
    },
    {
      heading: "Iams Shows Surge in Nutritional Value Recognition",
      summary:
        "Iams has gained significant recognition for its improved nutritional formulation compared to competitors.",
      insights: [
        "Nutritional value rating increased by 0.25 points",
        "Positive feedback from both consumers and critics regarding formulation quality",
      ],
      priority: "Low",
      time_period: ["2025 Q1", "2025 Q2"],
      consolidated_insight:
        "Iams’ nutritional upgrades boosted perception and consumer trust in brand health quality.",
      base_metric: "Nutritional_value",
      topic: "Product_quality",
      created_at: "2025-10-12T10:15:00Z",
    },
  ],
  [
    {
      "heading": "Hill's Expands Reach in Online Marketplaces",
      "summary": "Hill’s has significantly increased its online presence with partnerships in new e-commerce platforms.",
      "insights": [
        "Online sales up 15% QoQ",
        "Brand visibility in pet-focused e-commerce sites improved"
      ],
      "priority": "Medium",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Hill’s online distribution expansion boosts customer accessibility and brand recall.",
      "base_metric": "Sales",
      "topic": "Market_expansion",
      "created_at": "2025-11-11T16:09:00Z"
    },
    {
      "heading": "Hill's Expands Reach in Online Marketplaces",
      "summary": "Hill’s has significantly increased its online presence with partnerships in new e-commerce platforms.",
      "insights": [
        "Online sales up 15% QoQ",
        "Brand visibility in pet-focused e-commerce sites improved"
      ],
      "priority": "Medium",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Hill’s online distribution expansion boosts customer accessibility and brand recall.",
      "base_metric": "Sales",
      "topic": "Market_expansion",
      "created_at": "2025-11-10T15:45:00Z"
    },
    {
      "heading": "Hill's Expands Reach in Online Marketplaces",
      "summary": "Hill’s has significantly increased its online presence with partnerships in new e-commerce platforms.",
      "insights": [
        "Online sales up 15% QoQ",
        "Brand visibility in pet-focused e-commerce sites improved"
      ],
      "priority": "Medium",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Hill’s online distribution expansion boosts customer accessibility and brand recall.",
      "base_metric": "Sales",
      "topic": "Market_expansion",
      "created_at": "2025-11-09T14:30:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-11-08T11:00:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-11-07T09:15:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-11-06T14:00:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-11-05T10:30:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-11-04T13:45:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-11-03T11:00:00Z"
    },
    {
      "heading": "Purina Improves Packaging Experience Among Pet Owners",
      "summary": "Purina's new packaging design has resulted in improved storage satisfaction and handling experience among pet owners.",
      "insights": [
        "Packaging satisfaction increased by 20%",
        "User feedback highlights ease of use and reseal design as top improvements"
      ],
      "priority": "Medium",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Packaging design improvements contributed to higher customer satisfaction and better usability.",
      "base_metric": "Packaging",
      "topic": "Product_experience",
      "created_at": "2025-11-02T09:30:00Z"
    },
    {
      "heading": "Iams Shows Surge in Nutritional Value Recognition",
      "summary": "Iams has gained significant recognition for its improved nutritional formulation compared to competitors.",
      "insights": [
        "Nutritional value rating increased by 0.25 points",
        "Positive feedback from both consumers and critics regarding formulation quality"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Iams’ nutritional upgrades boosted perception and consumer trust in brand health quality.",
      "base_metric": "Nutritional_value",
      "topic": "Product_quality",
      "created_at": "2025-11-01T10:15:00Z"
    },
    {
      "heading": "Iams Shows Surge in Nutritional Value Recognition",
      "summary": "Iams has gained significant recognition for its improved nutritional formulation compared to competitors.",
      "insights": [
        "Nutritional value rating increased by 0.25 points",
        "Positive feedback from both consumers and critics regarding formulation quality"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Iams’ nutritional upgrades boosted perception and consumer trust in brand health quality.",
      "base_metric": "Nutritional_value",
      "topic": "Product_quality",
      "created_at": "2025-10-31T10:00:00Z"
    },
    {
      "heading": "Iams Shows Surge in Nutritional Value Recognition",
      "summary": "Iams has gained significant recognition for its improved nutritional formulation compared to competitors.",
      "insights": [
        "Nutritional value rating increased by 0.25 points",
        "Positive feedback from both consumers and critics regarding formulation quality"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Iams’ nutritional upgrades boosted perception and consumer trust in brand health quality.",
      "base_metric": "Nutritional_value",
      "topic": "Product_quality",
      "created_at": "2025-10-30T10:45:00Z"
    },
    {
      "heading": "Iams Shows Surge in Nutritional Value Recognition",
      "summary": "Iams has gained significant recognition for its improved nutritional formulation compared to competitors.",
      "insights": [
        "Nutritional value rating increased by 0.25 points",
        "Positive feedback from both consumers and critics regarding formulation quality"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Iams’ nutritional upgrades boosted perception and consumer trust in brand health quality.",
      "base_metric": "Nutritional_value",
      "topic": "Product_quality",
      "created_at": "2025-10-29T12:00:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-10-28T14:30:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-10-27T10:00:00Z"
    },
    {
      "heading": "Royal Canin Strengthens Position in Vet-Recommended Segment",
      "summary": "Royal Canin continues to dominate the vet-recommended space with new medical-grade formulations.",
      "insights": [
        "Market share increased by 8%",
        "Rated best in ‘Vet Recommendation’ category for Q2 2025"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Royal Canin reinforces leadership in veterinary nutrition with new specialized product lines.",
      "base_metric": "Market_share",
      "topic": "Professional_endorsement",
      "created_at": "2025-10-26T15:30:00Z"
    },
    {
      "heading": "Hill's Expands Reach in Online Marketplaces",
      "summary": "Hill’s has significantly increased its online presence with partnerships in new e-commerce platforms.",
      "insights": [
        "Online sales up 15% QoQ",
        "Brand visibility in pet-focused e-commerce sites improved"
      ],
      "priority": "Medium",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Hill’s online distribution expansion boosts customer accessibility and brand recall.",
      "base_metric": "Sales",
      "topic": "Market_expansion",
      "created_at": "2025-10-25T11:45:00Z"
    },
    {
      "heading": "Pedigree Faces Mixed Customer Reviews Amid Product Relaunch",
      "summary": "Pedigree’s relaunch has gained traction but also mixed feedback due to price sensitivity and packaging issues.",
      "insights": [
        "Positive sentiment up 10%, but negative sentiment also rose 5%",
        "Pricing strategy and packaging size cited as major pain points"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Pedigree’s relaunch brought visibility but created pricing and packaging concerns among consumers.",
      "base_metric": "Sentiment",
      "topic": "Brand_performance",
      "created_at": "2025-10-24T14:20:00Z"
    },
    {
      "heading": "Purina Expands into Emerging Pet Nutrition Categories",
      "summary": "Purina introduces plant-based and insect-protein pet food options as sustainability takes focus.",
      "insights": [
        "Introduced 3 new sustainable product lines",
        "Gained early adopter traction among eco-conscious consumers"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Purina’s sustainability-focused expansion opens new consumer segments and competitive differentiation.",
      "base_metric": "Product_launch",
      "topic": "Innovation",
      "created_at": "2025-10-23T10:45:00Z"
    },
    {
      "heading": "Blue Buffalo Launches Wellness-Based Campaign",
      "summary": "Blue Buffalo’s new campaign centers around holistic pet health, targeting premium buyers.",
      "insights": [
        "Campaign reach exceeds 3M users",
        "Engagement rates 25% higher than previous quarter"
      ],
      "priority": "Medium",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Wellness campaign success shows strong brand engagement and appeal among health-conscious pet owners.",
      "base_metric": "Engagement",
      "topic": "Marketing",
      "created_at": "2025-10-22T12:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-21T08:30:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-20T09:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-19T10:15:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-18T14:45:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-17T11:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-16T09:30:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-15T15:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-14T11:30:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-13T10:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-12T16:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-11T13:45:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-10T09:15:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-09T14:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-08T10:30:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-07T12:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-06T09:45:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-05T15:30:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-04T11:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-03T09:30:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-02T14:15:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-10-01T10:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-09-30T16:30:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-09-29T11:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-09-28T09:45:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-09-27T14:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-09-26T10:15:00Z"
    }
  ],
  [
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-11-11T16:15:00Z"
    },
    {
      "heading": "Pro Plan Faces Significant Declines While Hills Science Diet Gains Competitive Edge",
      "summary": "Pro Plan's ratings have sharply declined across multiple dimensions, while Hills Science Diet has shown notable improvements, highlighting critical areas for Pro Plan to address.",
      "insights": [
        "Rating for Pro Plan in Cat Food declined by 0.15708 from 2025 Q1 to 2025 Q2",
        "Rating for Hills Science Diet increased by 0.401062 from 2025 Q1 to 2025 Q2"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "- PRO PLAN's volume (LBS) declined by 0.78% from Q1 to Q2 2025, contrasting with a 1.1% increase in Private Label dog food volume, suggesting a shift in consumer preference.\n- The 'Volume (LBS) per Occasion' for PRO PLAN increased by 0.201667, outperforming the competitor's increase of 0.096333, indicating better performance in this dimension.\n- However, 'Volume (LBS) per Buying Household' for PRO PLAN increased by 0.735667, while the competitor's increase was 1.515333, highlighting a significant gap in household penetration.\n- PRO PLAN's 'Share of Volume (LBS)' decreased by -0.013667, while the competitor gained 0.378667, indicating a loss of market share for PRO PLAN.\n- The 'Percent Loyalty (Based on Volume)' for PRO PLAN increased by 1.268667, significantly outperforming the competitor's increase of 0.567333, suggesting stronger customer loyalty.\n- PRO PLAN's 'Value per Buying Household' is higher at 2.974 compared to the competitor's 1.8, indicating a stronger financial performance in this area.\n- The 'Value per Occasion' for PRO PLAN shows a change of 0.698333, significantly outperforming the competitor's 0.075333, reinforcing a stronger value proposition per occasion.\n- PRO PLAN's 'Percent Loyalty (Value)' increased by 0.965, while the competitor's value is 0.227333, indicating much higher loyalty based on value for PRO PLAN.\n- Overall, while PRO PLAN shows strengths in loyalty and value metrics, the decline in volume and share of volume compared to competitors signals potential risks to brand performance.",
      "base_metric": "Rating",
      "topic": "Consumer_rating",
      "created_at": "2025-11-10T11:45:00Z"
    },
    {
      "heading": "Royal Canin Strengthens Position in Vet-Recommended Segment",
      "summary": "Royal Canin continues to dominate the vet-recommended space with new medical-grade formulations.",
      "insights": [
        "Market share increased by 8%",
        "Rated best in ‘Vet Recommendation’ category for Q2 2025"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Royal Canin reinforces leadership in veterinary nutrition with new specialized product lines.",
      "base_metric": "Market_share",
      "topic": "Professional_endorsement",
      "created_at": "2025-11-09T09:30:00Z"
    },
    {
      "heading": "Hill's Expands Reach in Online Marketplaces",
      "summary": "Hill’s has significantly increased its online presence with partnerships in new e-commerce platforms.",
      "insights": [
        "Online sales up 15% QoQ",
        "Brand visibility in pet-focused e-commerce sites improved"
      ],
      "priority": "Medium",
      "time_period": [
        "2025 Q1",
        "2025 Q2"
      ],
      "consolidated_insight": "Hill’s online distribution expansion boosts customer accessibility and brand recall.",
      "base_metric": "Sales",
      "topic": "Market_expansion",
      "created_at": "2025-11-08T14:00:00Z"
    }
  ],
  [
    {
      "heading": "Pedigree Faces Mixed Customer Reviews Amid Product Relaunch",
      "summary": "Pedigree’s relaunch has gained traction but also mixed feedback due to price sensitivity and packaging issues.",
      "insights": [
        "Positive sentiment up 10%, but negative sentiment also rose 5%",
        "Pricing strategy and packaging size cited as major pain points"
      ],
      "priority": "High",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Pedigree’s relaunch brought visibility but created pricing and packaging concerns among consumers.",
      "base_metric": "Sentiment",
      "topic": "Brand_performance",
      "created_at": "2025-11-11T16:16:00Z"
    },
    {
      "heading": "Purina Expands into Emerging Pet Nutrition Categories",
      "summary": "Purina introduces plant-based and insect-protein pet food options as sustainability takes focus.",
      "insights": [
        "Introduced 3 new sustainable product lines",
        "Gained early adopter traction among eco-conscious consumers"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Purina’s sustainability-focused expansion opens new consumer segments and competitive differentiation.",
      "base_metric": "Product_launch",
      "topic": "Innovation",
      "created_at": "2025-11-10T14:00:00Z"
    },
    {
      "heading": "Blue Buffalo Launches Wellness-Based Campaign",
      "summary": "Blue Buffalo’s new campaign centers around holistic pet health, targeting premium buyers.",
      "insights": [
        "Campaign reach exceeds 3M users",
        "Engagement rates 25% higher than previous quarter"
      ],
      "priority": "Medium",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Wellness campaign success shows strong brand engagement and appeal among health-conscious pet owners.",
      "base_metric": "Engagement",
      "topic": "Marketing",
      "created_at": "2025-11-09T10:30:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-11-08T15:15:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-11-07T11:00:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-11-06T09:45:00Z"
    },
    {
      "heading": "Hill’s Science Diet Shows Consistent Growth in Premium Category",
      "summary": "Hill’s maintains steady growth, especially in the premium dry food category.",
      "insights": [
        "Revenue growth 12% YoY",
        "Customer retention improved 5% due to loyalty program revamp"
      ],
      "priority": "Low",
      "time_period": [
        "2025 Q2",
        "2025 Q3"
      ],
      "consolidated_insight": "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
      "base_metric": "Revenue",
      "topic": "Growth",
      "created_at": "2025-11-05T14:30:00Z"
    }
  ],
  // [
  //   {
  //     heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //     summary:
  //       "Hill’s maintains steady growth, especially in the premium dry food category.",
  //     insights: [
  //       "Revenue growth 12% YoY",
  //       "Customer retention improved 5% due to loyalty program revamp",
  //     ],
  //     priority: "Low",
  //     time_period: ["2025 Q2", "2025 Q3"],
  //     consolidated_insight:
  //       "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //     base_metric: "Revenue",
  //     topic: "Growth",
  //   },
  //   {
  //     heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //     summary:
  //       "Hill’s maintains steady growth, especially in the premium dry food category.",
  //     insights: [
  //       "Revenue growth 12% YoY",
  //       "Customer retention improved 5% due to loyalty program revamp",
  //     ],
  //     priority: "Low",
  //     time_period: ["2025 Q2", "2025 Q3"],
  //     consolidated_insight:
  //       "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //     base_metric: "Revenue",
  //     topic: "Growth",
  //   }
  // ],
  // [{
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }, {
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }],
  // [{
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }, {
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }],
  // [{
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }, {
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }],
  // [{
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }, {
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }],
  // [{
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }, {
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }],
  // [{
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }, {
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }],
  // [{
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }, {
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }],
  // [],
  // [{
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }, {
  //   heading: "Hill’s Science Diet Shows Consistent Growth in Premium Category",
  //   summary:
  //     "Hill’s maintains steady growth, especially in the premium dry food category.",
  //   insights: [
  //     "Revenue growth 12% YoY",
  //     "Customer retention improved 5% due to loyalty program revamp",
  //   ],
  //   priority: "Low",
  //   time_period: ["2025 Q2", "2025 Q3"],
  //   consolidated_insight:
  //     "Hill’s stable premium growth demonstrates strong brand trust and customer loyalty.",
  //   base_metric: "Revenue",
  //   topic: "Growth",
  // }],
];

const miniCardDetails = {
  "Sales Performance": [
    {
      "label": "Velocity",
      "value": "94.2",
      "change": "+8.5%",
      "trend": "up"
    },
    {
      "label": "Dollar Sales ($)",
      "value": "$248.5K",
      "change": "+12.5%",
      "trend": "up"
    },
    {
      "label": "Volume/Tonnage",
      "value": "2347",
      "change": "+9.8%",
      "trend": "up"
    },
    {
      "label": "Market Share = $",
      "value": "$77.8K",
      "change": "-$3.0K",
      "trend": "down"
    },
    {
      "label": "LB Share",
      "value": "28.7%",
      "change": "-0.8%",
      "trend": "down"
    },
    {
      "label": "LB Share",
      "value": "28.7%",
      "change": "-0.8%",
      "trend": "down"
    }
  ],
  "Household Health": [
    {
      "label": "#Households",
      "value": "2,156",
      "change": "+15.2%",
      "trend": "up"
    },
    {
      "label": "Purchase Freq",
      "value": "2.3x/mo",
      "change": "+0.2",
      "trend": "up"
    },
    {
      "label": "$buying rate",
      "value": "$112.80",
      "change": "+4.2%",
      "trend": "up"
    },
    {
      "label": "Penetration",
      "value": "42.8%",
      "change": "+3.1%",
      "trend": "up"
    },
    {
      "label": "%Loyalty",
      "value": "78%",
      "change": "+3%",
      "trend": "up"
    },
    {
      "label": "Value/Buyer",
      "value": "$112.80",
      "change": "+3.5%",
      "trend": "up"
    },
    {
      "label": "Repeat Buyers",
      "value": "1,678",
      "change": "+12.3%",
      "trend": "up"
    }
  ],
  "Voice of Consumer": [
    {
      "label": "Avg Star Rating",
      "value": "4.7",
      "change": "+0.3",
      "trend": "up"
    },
    {
      "label": "Overall Sentiment",
      "value": "68%",
      "change": "+4%",
      "trend": "up"
    },
    {
      "label": "Volume of Reviews",
      "value": "341",
      "change": "+20%",
      "trend": "up"
    },
    {
      "label": "Star Ratings",
      "value": "4.5 avg",
      "change": "+0.2",
      "trend": "up"
    },
    {
      "label": "Key Topics",
      "value": "456",
      "change": "+15%",
      "trend": "up"
    }
  ]
}

const topicdetails = [
  {
    "id": 1,
    "name": "Sales Performance",
    "description": "Quarterly sales performance metrics and trends",
    "source": "Nielsen RMS",
    "market": "US Market",
    "latest_data_update": "2024-01-15T00:00:00Z",
    "default_dimensions": ["Brand", "Category", "Region"],
    "created_at": "2024-01-01T00:00:00Z",
    "updated_at": "2024-01-15T00:00:00Z",
    "display_order": 1
  },
  {
    "id": 2,
    "name": "Household Health",
    "description": "Quarterly sales performance metrics and trends",
    "source": "Nielsen HomeScan Rolling",
    "market": "US Market",
    "latest_data_update": "2024-01-15T00:00:00Z",
    "default_dimensions": ["Brand", "Category", "Region"],
    "created_at": "2024-01-01T00:00:00Z",
    "updated_at": "2024-01-15T00:00:00Z",
    "display_order": 2
  },
  {
    "id": 3,
    "name": "Voice of Consumer",
    "description": "Quarterly sales performance metrics and trends",
    "source": "Yogi Consumer Rating and Reviews",
    "market": "US Market",
    "latest_data_update": "2024-01-15T00:00:00Z",
    "default_dimensions": ["Brand", "Category", "Region"],
    "created_at": "2024-01-01T00:00:00Z",
    "updated_at": "2024-01-15T00:00:00Z",
    "display_order": 3
  }

]

const metricDetails = [
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 1,
    "value": 12.75,
    "time_marker": "YTD",
    "delta": {
      "time_marker": "YAG",
      "trend": "positive",
      "value": 1.25,
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars3",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 3,
    "value": 1.75,
    "delta": {
      "value": 12.25,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars2",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": false,
    "display_order": 2,
    "value": 12.5,
    "delta": {
      "value": 11.25,
      "trend": "negative",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars5",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 5,
    "value": 1,
    "delta": {
      "value": 1.25,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars4",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": false,
    "display_order": 4,
    "value": 12.75,
    "delta": {
      "value": 1.25,
      "trend": "negative",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 2,
    "name": "Loyalty",
    "units": [
      { "prefix": false, "unit": "%" }
    ],
    "insights_display_enabled": false,
    "display_order": 2,
    "value": 8.5,
    "delta": {
      "value": 2.1,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Yogi"
  },
  {
    "parent_type": "topic",
    "parent_id": 2,
    "name": "Total Dollars5",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 3,
    "value": 1,
    "delta": {
      "value": 1.25,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 2,
    "name": "Total Dollars4",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": false,
    "display_order": 1,
    "value": 12.75,
    "delta": {
      "value": 1.25,
      "trend": "negative",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 3,
    "name": "Loyalty",
    "units": [
      { "prefix": false, "unit": "%" }
    ],
    "insights_display_enabled": false,
    "display_order": 2,
    "value": 8.5,
    "delta": {
      "value": 2.1,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Yogi"
  },
  {
    "parent_type": "topic",
    "parent_id": 3,
    "name": "Total Dollars5",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 3,
    "value": 1,
    "delta": {
      "value": 1.25,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 3,
    "name": "Total Dollars4",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": false,
    "display_order": 1,
    "value": 12.75,
    "delta": {
      "value": 1.25,
      "trend": "negative",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  }
]

const filterMetricDetails = [
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 1,
    "value": 12.75,
    "delta": {
      "value": 1.25,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" },
      "time_marker": "52 Weeks"
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars3",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 3,
    "value": 1.75,
    "delta": {
      "value": 12.25,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars2",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 2,
    "value": 12.5,
    "delta": {
      "value": 11.25,
      "trend": "negative",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "name": "Total Dollars5",
    "units": [
      { "prefix": false, "unit": "B" },
      { "prefix": true, "unit": "$" }
    ],
    "insights_display_enabled": true,
    "display_order": 5,
    "value": 1,
    "delta": {
      "value": 1.25,
      "trend": "positive",
      "unit": { "prefix": false, "unit": "%" }
    },
    "source": "Neilsen RMS"
  }
]

const filters = {
  "data": [
    {
      "title": "Date Range",
      "parent_type": "topic",
      "parent_id": 1,
      "values": [
        "YTD",
        "Last 4 Weeks",
        "Last 12 Weeks",
        "Last 52 Weeks"
      ],
      "hierarchy": 1,
      "default_value": "YTD",
      "validation": null
    },
    {
      "title": "Brand Group",
      "parent_type": "topic",
      "parent_id": 1,
      "values": [
        "Pro Plan"
      ],
      "hierarchy": 2,
      "default_value": "Pro Plan",
      "validation": { "lower_dimension": "Category", "valid_values": { "Pro Plan": ["All", "Cat Food", "Dog Food"] } }
    },
    {
      "title": "Category",
      "parent_type": "topic",
      "parent_id": 1,
      "values": [
        "All",
        "Cat Food",
        "Dog Food"
      ],
      "hierarchy": 3,
      "default_value": "All",
      "validation": { "lower_dimension": "Segment", "valid_values": { "All": ["All"], "Cat Food": ["All", "Dry Cat", "Wet Cat"], "Dog Food": ["All", "Dry Dog", "Wet Dog"] } }
    },
    {
      "title": "Segment",
      "parent_type": "topic",
      "parent_id": 1,
      "values": [
        "All",
        "Dry Cat",
        "Dry Dog",
        "Wet Dog",
        "Wet Cat"
      ],
      "hierarchy": 4,
      "default_value": "All",
      "validation": null
    },
    {
      "title": "Date Range",
      "parent_type": "topic",
      "parent_id": 2,
      "values": [
        "4 weeks ago",
        "12 weeks ago",
        "52 weeks ago"
      ],
      "hierarchy": 1,
      "default_value": "52 weeks ago",
      "validation": null
    },
    {
      "title": "Brand Group",
      "parent_type": "topic",
      "parent_id": 2,
      "values": [
        "Pro Plan"
      ],
      "hierarchy": 2,
      "default_value": "Pro Plan",
      "validation": null
    },
    {
      "title": "Category",
      "parent_type": "topic",
      "parent_id": 2,
      "values": [
        "Cat Food",
        "Dog Food"
      ],
      "hierarchy": 3,
      "default_value": "Cat Food",
      "validation": null
    },
    {
      "title": "Segment",
      "parent_type": "topic",
      "parent_id": 2,
      "values": [
        "All"
      ],
      "hierarchy": 4,
      "default_value": "All",
      "validation": null
    },
    {
      "title": "Date Range",
      "parent_type": "topic",
      "parent_id": 3,
      "values": [
        "YTD",
        "Last 4 Weeks",
        "Last 12 Weeks",
        "Last 52 Weeks"
      ],
      "hierarchy": 1,
      "default_value": "YTD",
      "validation": null
    },
    {
      "title": "Brand Group",
      "parent_type": "topic",
      "parent_id": 3,
      "values": [
        "Pro Plan"
      ],
      "hierarchy": 2,
      "default_value": "Pro Plan",
      "validation": null
    },
    {
      "title": "Category",
      "parent_type": "topic",
      "parent_id": 3,
      "values": [
        "All",
        "Cat Food",
        "Dog Food"
      ],
      "hierarchy": 3,
      "default_value": "All",
      "validation": null
    },
    {
      "title": "Segment",
      "parent_type": "topic",
      "parent_id": 3,
      "values": [
        "All",
        "Dry Cat",
        "Dry Dog",
        "Wet Dog",
        "Wet Cat"
      ],
      "hierarchy": 4,
      "default_value": "All",
      "validation": null
    }
  ]
}

const chartResponse = [
  {
    "id": 1,
    "parent_type": "topic",
    "parent_id": 1,
    "title": "TDP",
    "type": "line",
    "display_order": 1,
    "data": {
      "x_axis": {
        "type": "date",
        "field": "end_period",
        "display_name": "Time Line",
        "values": [
          "2024-11-16T00:00:00+00:00",
          "2024-12-14T00:00:00+00:00",
          "2025-01-11T00:00:00+00:00",
          "2025-02-08T00:00:00+00:00",
          "2025-03-08T00:00:00+00:00",
          "2025-04-05T00:00:00+00:00",
          "2025-05-03T00:00:00+00:00",
          "2025-05-31T00:00:00+00:00",
          "2025-06-28T00:00:00+00:00",
          "2025-07-26T00:00:00+00:00",
          "2025-08-23T00:00:00+00:00",
          "2025-09-20T00:00:00+00:00",
          "2025-10-18T00:00:00+00:00"
        ],
        "format": "%b %Y",
        "sort_order": "asc"
      },
      "y_axes": [
        {
          "id": "y1",
          "position": "left",
          "display_name": "TDP",
          "type": "value",
          "format": "0.00",
          "min": null,
          "max": null
        }
      ],
      "series": [
        {
          "id": "metric_6",
          "name": "TDPs",
          "type": "line",
          "data": [
            893.8223499999999,
            816.4664249999998,
            847.3519249999999,
            845.350625,
            842.396375,
            877.2508249999998,
            891.0147750000001,
            899.347875,
            922.77935,
            887.3338000000001,
            905.38405,
            933.58005,
            925.303075
          ],
          "y_axis_id": "y1"
        }
      ]
    },
    "metric_ids": [
      6
    ],
    "filters_applied": {
      "dimensions": {
        "Brand Group": [
          "Pro Plan"
        ],
        "Category": [
          "All"
        ],
        "Segment": [
          "All"
        ]
      },
      "time_granularity": {
        "granularity": "YTD",
        "range_type": "all",
        "start_date": null,
        "end_date": null,
        "latest_count": null
      }
    }
  },
  {
    "id": 2,
    "parent_type": "topic",
    "parent_id": 1,
    "title": "Total Market Sales Vs Pro Plan Sales",
    "type": "line",
    "display_order": 2,
    "data": {
      "x_axis": {
        "type": "date",
        "field": "end_period",
        "display_name": "Time Line",
        "values": [
          "2024-11-16T00:00:00+00:00",
          "2024-12-14T00:00:00+00:00",
          "2025-01-11T00:00:00+00:00",
          "2025-02-08T00:00:00+00:00",
          "2025-03-08T00:00:00+00:00",
          "2025-04-05T00:00:00+00:00",
          "2025-05-03T00:00:00+00:00",
          "2025-05-31T00:00:00+00:00",
          "2025-06-28T00:00:00+00:00",
          "2025-07-26T00:00:00+00:00",
          "2025-08-23T00:00:00+00:00",
          "2025-09-20T00:00:00+00:00",
          "2025-10-18T00:00:00+00:00"
        ],
        "format": "%b %Y",
        "sort_order": "asc"
      },
      "y_axes": [
        {
          "id": "y1",
          "position": "left",
          "display_name": "Total Market Sales($B)",
          "type": "value",
          "format": "0",
          "min": null,
          "max": null
        },
        {
          "id": "y2",
          "position": "right",
          "display_name": "Pro Plan Sales($M)",
          "type": "value",
          "format": "0",
          "min": null,
          "max": null
        }
      ],
      "series": [
        {
          "id": "metric_1",
          "name": "Consumption - Total Dollars($)",
          "type": "line",
          "data": [
            200431607.1533,
            189376486.026,
            197485180.28640005,
            199032131.80120003,
            196113596.5991,
            202003943.8719,
            204956053.6537,
            203132716.4669,
            206237874.8838,
            202486508.6527,
            206192384.9465,
            210186573.4913,
            209665372.8532
          ],
          "y_axis_id": "y2"
        },
        {
          "id": "metric_16",
          "name": "Total Market Sales($)",
          "type": "line",
          "data": [
            3701990108.315501,
            3670240210.249497,
            3617159076.127399,
            3655895061.003898,
            3558479842.4139986,
            3547183685.9176025,
            3564131596.107004,
            3540816342.327995,
            3555069808.049092,
            3537984571.4231977,
            3575525639.480899,
            3633712896.307304,
            3655901423.923395
          ],
          "y_axis_id": "y1"
        }
      ]
    },
    "metric_ids": [
      1,
      16
    ],
    "filters_applied": {
      "dimensions": {
        "Brand Group": [
          "Pro Plan"
        ],
        "Category": [
          "All"
        ],
        "Segment": [
          "All"
        ]
      },
      "time_granularity": {
        "granularity": "YTD",
        "range_type": "all",
        "start_date": null,
        "end_date": null,
        "latest_count": null
      }
    }
  },
  {
    "id": 3,
    "parent_type": "topic",
    "parent_id": 1,
    "title": "Total Market Tonnage Vs Pro Plan Tonnage",
    "type": "line",
    "display_order": 3,
    "data": {
      "x_axis": {
        "type": "date",
        "field": "end_period",
        "display_name": "Time Line",
        "values": [
          "2024-11-16T00:00:00+00:00",
          "2024-12-14T00:00:00+00:00",
          "2025-01-11T00:00:00+00:00",
          "2025-02-08T00:00:00+00:00",
          "2025-03-08T00:00:00+00:00",
          "2025-04-05T00:00:00+00:00",
          "2025-05-03T00:00:00+00:00",
          "2025-05-31T00:00:00+00:00",
          "2025-06-28T00:00:00+00:00",
          "2025-07-26T00:00:00+00:00",
          "2025-08-23T00:00:00+00:00",
          "2025-09-20T00:00:00+00:00",
          "2025-10-18T00:00:00+00:00"
        ],
        "format": "%b %Y",
        "sort_order": "asc"
      },
      "y_axes": [
        {
          "id": "y1",
          "position": "left",
          "display_name": "Total Market Tonnage(lb M)",
          "type": "value",
          "format": "0",
          "min": null,
          "max": null
        },
        {
          "id": "y2",
          "position": "right",
          "display_name": "Pro Plan Tonnage(lb M)",
          "type": "value",
          "format": "0",
          "min": null,
          "max": null
        }
      ],
      "series": [
        {
          "id": "metric_2",
          "name": "Total Tonnage (Lb)",
          "type": "line",
          "data": [
            75927928.5404,
            70116645.9769,
            73727569.0456,
            74478646.13929999,
            73053356.4631,
            72043088.11959998,
            72814490.5555,
            71526881.38229999,
            72018860.2519,
            70878630.25160001,
            72164129.5605,
            74342485.68040001,
            73374397.6262
          ],
          "y_axis_id": "y2"
        },
        {
          "id": "metric_17",
          "name": "Total Market Tonnage (Lb)",
          "type": "line",
          "data": [
            1437155584.9626,
            1417989846.801499,
            1421141988.183498,
            1427727515.6308987,
            1383506270.4470005,
            1367810921.2883973,
            1371762395.3480012,
            1351964488.4125,
            1344693910.483101,
            1341146530.4046018,
            1356073926.9653995,
            1380674618.7206995,
            1401850145.7392993
          ],
          "y_axis_id": "y1"
        }
      ]
    },
    "metric_ids": [
      2,
      17
    ],
    "filters_applied": {
      "dimensions": {
        "Brand Group": [
          "Pro Plan"
        ],
        "Category": [
          "All"
        ],
        "Segment": [
          "All"
        ]
      },
      "time_granularity": {
        "granularity": "YTD",
        "range_type": "all",
        "start_date": null,
        "end_date": null,
        "latest_count": null
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "title": "TDP",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 1,

    "data": {
      "x_axis": {
        "type": "date",
        "field": "end_period",
        "display_name": "Time Line",
        "values": [
          "2024-11-16T00:00:00+00:00",
          "2024-12-14T00:00:00+00:00",
          "2025-01-11T00:00:00+00:00",
          "2025-02-08T00:00:00+00:00",
          "2025-03-08T00:00:00+00:00",
          "2025-04-05T00:00:00+00:00",
          "2025-05-03T00:00:00+00:00",
          "2025-05-31T00:00:00+00:00",
          "2025-06-28T00:00:00+00:00",
          "2025-07-26T00:00:00+00:00",
          "2025-08-23T00:00:00+00:00",
          "2025-09-20T00:00:00+00:00",
          "2025-10-18T00:00:00+00:00"
        ],
        "format": "%b %Y",
        "sort_order": "asc"
      },
      "y_axes": [
        {
          "id": "y1",
          "position": "left",
          "display_name": "TDP",
          "type": "value",
          "format": "0.00",
          "min": null,
          "max": null
        }
      ],
      "series": [
        {
          "id": "metric_6",
          "name": "TDPs",
          "type": "line",
          "data": [
            893.8223499999999,
            816.4664249999998,
            847.3519249999999,
            845.350625,
            842.396375,
            877.2508249999998,
            891.0147750000001,
            899.347875,
            922.77935,
            887.3338000000001,
            905.38405,
            933.58005,
            925.303075
          ],
          "y_axis_id": "y1"
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "title": "Monthly Sales & Conversion Rate",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 1,

    "data": {
      "type": "mixed",

      // "layout": {
      //   "barmode": "group",
      //   "showlegend": true,
      //   "legend": {
      //     "orientation": "h",
      //     "x": 0,
      //     "y": -0.2
      //   }
      // },

      "x_axis": {
        "values": ["2024-01", "2024-02", "2024-03"],
        "type": "category",
        "display_name": "Month",
        "format": "%b %Y"
      },

      "y_axes": [
        {
          "id": "y1",
          "display_name": "Sales ($)",
          "side": "left",
          "type": "linear",
          "format": "$,.0f"
        },
        {
          "id": "y2",
          "display_name": "Conversion Rate (%)",
          "side": "right",
          "overlaying": "y",
          "type": "linear",
          "format": ".1%"
        }
      ],

      "series": [
        {
          "id": "s1",
          "name": "Sales",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [120000, 150000, 130000],
          "marker": {
            "color": "#4287f5"
          }
        },
        {
          "id": "s2",
          "name": "Conversion Rate",
          "type": "line",
          "y_axis_id": "y2",
          "mode": "lines+markers",
          "data": [0.034, 0.041, 0.038],
          "line": {
            "width": 3
          },
          "marker": {
            "size": 8
          }
        }
      ],

      // "annotations": [
      //   {
      //     "x": "2024-02",
      //     "y": 150000,
      //     "text": "Peak Sales",
      //     "showarrow": true,
      //     "arrowhead": 2
      //   }
      // ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 3,

    "data": {
      "type": "mixed",

      "layout": {
        "barmode": "group",
        "showlegend": true,
        "legend": {
          "orientation": "h",
          "x": 0,
          "y": -0.2
        }
      },

      "x_axis": {
        "values": ["2024-Q1", "2024-Q2", "2024-Q3", "2024-Q4"],
        "type": "category",
        "display_name": "Quarter",
        "format": "%b %Y"
      },

      "y_axes": [
        {
          "id": "y1",
          "display_name": "Revenue ($)",
          "side": "left",
          "type": "linear",
          "format": "$,.0f"
        },
        {
          "id": "y2",
          "display_name": "Growth Rate (%)",
          "side": "right",
          "overlaying": "y",
          "type": "linear",
          "format": ".1%"
        }
      ],

      "series": [
        {
          "id": "bar1",
          "name": "Revenue",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [400000, 450000, 470000, 520000],
          "marker": {
            "color": "#4287f5"
          }
        },
        {
          "id": "line1",
          "name": "Growth Rate",
          "type": "line",
          "mode": "lines+markers",
          "y_axis_id": "y2",
          "data": [0.05, 0.07, 0.06, 0.08],
          "line": {
            "width": 3
          },
          "marker": {
            "size": 8
          }
        },
        {
          "id": "area1",
          "name": "Cumulative Revenue",
          "type": "area",
          "y_axis_id": "y1",
          "data": [400000, 850000, 1320000, 1840000],
          "fill": "tozeroy",
          "line": {
            "width": 2
          },
          "marker": {
            "color": "rgba(66,135,245,0.3)"
          }
        }
      ],

      "annotations": [
        {
          "x": "2024-Q4",
          "y": 520000,
          "text": "Highest Quarterly Revenue",
          "showarrow": true,
          "arrowhead": 2
        }
      ]
    }
    ,

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 2,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 1,

    "data": {
      "type": "mixed",

      "layout": {
        "barmode": "group",
        "showlegend": true,
        "legend": {
          "orientation": "h",
          "x": 0,
          "y": -0.2
        }
      },

      "x_axis": {
        "values": ["2024-01", "2024-02", "2024-03"],
        "type": "category",
        "title": "Month",
        "format": "%b %Y"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Sales ($)",
          "side": "left",
          "type": "linear",
          "format": "$,.0f"
        },
        {
          "id": "y2",
          "title": "Conversion Rate (%)",
          "side": "right",
          "overlaying": "y",
          "type": "linear",
          "format": ".1%"
        }
      ],

      "series": [
        {
          "id": "s1",
          "name": "Sales",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [120000, 150000, 130000],
          "marker": {
            "color": "#4287f5"
          }
        },
        {
          "id": "s2",
          "name": "Conversion Rate",
          "type": "line",
          "y_axis_id": "y2",
          "mode": "lines+markers",
          "data": [0.034, 0.041, 0.038],
          "line": {
            "width": 3
          },
          "marker": {
            "size": 8
          }
        }
      ],

      "annotations": [
        {
          "x": "2024-02",
          "y": 150000,
          "text": "Peak Sales",
          "showarrow": true,
          "arrowhead": 2
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 3,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 2,

    "data": {
      "type": "mixed",

      "layout": {
        "showlegend": true
      },

      "x_axis": {
        "values": [10, 20, 30, 40, 50, 60],
        "type": "linear",
        "title": "Load Time (ms)"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Frequency",
          "side": "left",
          "type": "linear"
        },
        {
          "id": "y2",
          "title": "Cumulative %",
          "side": "right",
          "overlaying": "y",
          "type": "linear",
          "format": ".0%"
        }
      ],

      "series": [
        {
          "id": "h1",
          "name": "Load Time Distribution",
          "type": "histogram",
          "y_axis_id": "y1",
          "data": [12, 22, 25, 28, 33, 37, 45, 52, 58, 60],
          "marker": {
            "color": "#9b59b6"
          }
        },
        {
          "id": "a1",
          "name": "Cumulative %",
          "type": "area",
          "y_axis_id": "y2",
          "data": [0.1, 0.25, 0.4, 0.6, 0.8, 1.0],
          "fill": "tozeroy",
          "line": { "width": 2 },
          "marker": {
            "color": "rgba(155,89,182,0.3)"
          }
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 3,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 1,

    "data": {
      "type": "mixed",

      "layout": {
        "showlegend": true,
        "barmode": "overlay"
      },

      "x_axis": {
        "values": ["A", "B", "C", "D", "E"],
        "type": "category",
        "title": "Product"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Units Sold",
          "side": "left",
          "type": "linear"
        }
      ],

      "series": [
        {
          "id": "h1",
          "name": "Sales Frequency",
          "type": "histogram",
          "y_axis_id": "y1",
          "data": ["A", "A", "A", "B", "C", "C", "D", "E", "E", "E", "E"],
          "marker": {
            "color": "rgba(255,140,0,0.6)"
          }
        },
        {
          "id": "b1",
          "name": "Avg Sales Value",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [30, 50, 45, 25, 60],
          "marker": {
            "color": "#4287f5"
          }
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 2,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 2,

    "data": {
      "type": "mixed",

      "layout": {
        "showlegend": true
      },

      "x_axis": {
        "values": [5, 8, 10, 12, 15, 18, 20, 22, 30, 35, 40],
        "type": "linear",
        "title": "Customer Age"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Frequency",
          "side": "left",
          "type": "linear"
        },
        {
          "id": "y2",
          "title": "Satisfaction Score",
          "side": "right",
          "overlaying": "y",
          "type": "linear"
        }
      ],

      "series": [
        {
          "id": "h1",
          "name": "Age Distribution",
          "type": "histogram",
          "y_axis_id": "y1",
          "data": [5, 8, 10, 12, 15, 18, 20, 22, 30, 35, 40],
          "marker": {
            "color": "#7f82f0"
          }
        },
        {
          "id": "l1",
          "name": "Avg Satisfaction",
          "type": "line",
          "mode": "lines+markers",
          "y_axis_id": "y2",
          "data": [3.8, 4.0, 4.4, 4.6, 4.7, 4.8, 4.9, 5.0, 4.8, 4.6, 4.4],
          "line": { "width": 3 },
          "marker": { "size": 6 }
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  }
]

const filteredChartResponse = [
  {
    "parent_type": "topic",
    "parent_id": 1,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 1,

    "data": {
      "type": "mixed",

      "layout": {
        "barmode": "group",
        "showlegend": true,
        "legend": {
          "orientation": "h",
          "x": 0,
          "y": -0.2
        }
      },

      "x_axis": {
        "values": ["2024-01", "2024-02", "2024-03"],
        "type": "category",
        "title": "Month",
        "format": "%b %Y"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Sales ($)",
          "side": "left",
          "type": "linear",
          "format": "$,.0f"
        },
        {
          "id": "y2",
          "title": "Conversion Rate (%)",
          "side": "right",
          "overlaying": "y",
          "type": "linear",
          "format": ".1%"
        }
      ],

      "series": [
        {
          "id": "s1",
          "name": "Sales",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [120000, 150000, 130000],
          "marker": {
            "color": "#4287f5"
          }
        },
        {
          "id": "s2",
          "name": "Conversion Rate",
          "type": "line",
          "y_axis_id": "y2",
          "mode": "lines+markers",
          "data": [0.034, 0.041, 0.038],
          "line": {
            "width": 3
          },
          "marker": {
            "size": 8
          }
        }
      ],

      "annotations": [
        {
          "x": "2024-02",
          "y": 150000,
          "text": "Peak Sales",
          "showarrow": true,
          "arrowhead": 2
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 3,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 1,

    "data": {
      "type": "mixed",

      "layout": {
        "showlegend": true,
        "barmode": "overlay"
      },

      "x_axis": {
        "values": ["A", "B", "C", "D", "E"],
        "type": "category",
        "title": "Product"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Units Sold",
          "side": "left",
          "type": "linear"
        }
      ],

      "series": [
        {
          "id": "h1",
          "name": "Sales Frequency",
          "type": "histogram",
          "y_axis_id": "y1",
          "data": ["A", "A", "A", "B", "C", "C", "D", "E", "E", "E", "E"],
          "marker": {
            "color": "rgba(255,140,0,0.6)"
          }
        },
        {
          "id": "b1",
          "name": "Avg Sales Value",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [30, 50, 45, 25, 60],
          "marker": {
            "color": "#4287f5"
          }
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 2,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 2,

    "data": {
      "type": "mixed",

      "layout": {
        "showlegend": true
      },

      "x_axis": {
        "values": [5, 8, 10, 12, 15, 18, 20, 22, 30, 35, 40],
        "type": "linear",
        "title": "Customer Age"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Frequency",
          "side": "left",
          "type": "linear"
        },
        {
          "id": "y2",
          "title": "Satisfaction Score",
          "side": "right",
          "overlaying": "y",
          "type": "linear"
        }
      ],

      "series": [
        {
          "id": "h1",
          "name": "Age Distribution",
          "type": "histogram",
          "y_axis_id": "y1",
          "data": [5, 8, 10, 12, 15, 18, 20, 22, 30, 35, 40],
          "marker": {
            "color": "#7f82f0"
          }
        },
        {
          "id": "l1",
          "name": "Avg Satisfaction",
          "type": "line",
          "mode": "lines+markers",
          "y_axis_id": "y2",
          "data": [3.8, 4.0, 4.4, 4.6, 4.7, 4.8, 4.9, 5.0, 4.8, 4.6, 4.4],
          "line": { "width": 3 },
          "marker": { "size": 6 }
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  }
]

const filtersEvent = {
  "data": [
    {
      "title": "Event Name",
      "parent_type": "event",
      "parent_id": 1,
      "values": [
        "Price Change Event"
      ],
      "hierarchy": 1,
      "default_value": "Price Change Event",
      "validation": {}
    },
    {
      "title": "Time Period",
      "parent_type": "event",
      "parent_id": 1,
      "values": [
        "Jan 1 to Jun 30 2025"
      ],
      "hierarchy": 2,
      "default_value": "Jan 1 to Jun 30 2025",
      "validation": {}
    }
  ]
}

const eventMetricDetails = [{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": true,
  "display_order": 1,
  "value": 12.75,
  "trend": "positive",
  "delta": {
    "value": 1.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
},
{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars3",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": true,
  "display_order": 3,
  "value": 1.75,
  "trend": "positive",
  "delta": {
    "value": 12.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
},
{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars2",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": false,
  "display_order": 2,
  "value": 12.5,
  "trend": "negative",
  "delta": {
    "value": 11.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
},
{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars5",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": true,
  "display_order": 5,
  "value": 1,
  "trend": "positive",
  "delta": {
    "value": 1.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
},
{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars4",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": false,
  "display_order": 4,
  "value": 12.75,
  "trend": "negative",
  "delta": {
    "value": 1.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
}]

const filteredEventMetricDetails = [{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": true,
  "display_order": 1,
  "value": 12.75,
  "trend": "positive",
  "delta": {
    "value": 1.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
},
{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars3",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": true,
  "display_order": 3,
  "value": 1.75,
  "trend": "positive",
  "delta": {
    "value": 12.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
},
{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars2",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": false,
  "display_order": 2,
  "value": 12.5,
  "trend": "negative",
  "delta": {
    "value": 11.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
},
{
  "parent_type": "topic",
  "parent_id": 1,
  "name": "Total Dollars5",
  "units": [
    { "prefix": false, "unit": "B" },
    { "prefix": true, "unit": "$" }
  ],
  "insights_display_enabled": true,
  "display_order": 5,
  "value": 1,
  "trend": "positive",
  "delta": {
    "value": 1.25,
    "unit": { "prefix": false, "unit": "%" }
  },
  "source": "Neilsen RMS"
}
]

const eventChartDetails = [
  {
    "parent_type": "topic",
    "parent_id": 1,
    "title": "Monthly Sales & Conversion Rate second",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 2,

    "data": {
      "type": "mixed",

      "layout": {
        "barmode": "group",
        "showlegend": true,
        "legend": {
          "orientation": "h",
          "x": 0,
          "y": -0.2
        }
      },

      "x_axis": {
        "values": ["2024-01", "2024-02", "2024-03"],
        "type": "category",
        "title": "Month",
        "format": "%b %Y"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Sales ($)",
          "side": "left",
          "type": "linear",
          "format": "$,.0f"
        },
        {
          "id": "y2",
          "title": "Conversion Rate (%)",
          "side": "right",
          "overlaying": "y",
          "type": "linear",
          "format": ".1%"
        }
      ],

      "series": [
        {
          "id": "s1",
          "name": "Sales",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [120000, 150000, 130000],
          "marker": {
            "color": "#4287f5"
          }
        },
        {
          "id": "s2",
          "name": "Conversion Rate",
          "type": "line",
          "y_axis_id": "y2",
          "mode": "lines+markers",
          "data": [0.034, 0.041, 0.038],
          "line": {
            "width": 3
          },
          "marker": {
            "size": 8
          }
        }
      ],

      "annotations": [
        {
          "x": "2024-02",
          "y": 150000,
          "text": "Peak Sales",
          "showarrow": true,
          "arrowhead": 2
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
  {
    "parent_type": "topic",
    "parent_id": 1,
    "title": "Monthly Sales & Conversion Rate",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 1,

    "data": {
      "type": "mixed",

      "layout": {
        "barmode": "group",
        "showlegend": true,
        "legend": {
          "orientation": "h",
          "x": 0,
          "y": -0.2
        }
      },

      "x_axis": {
        "values": ["2024-01", "2024-02", "2024-03"],
        "type": "category",
        "title": "Month",
        "format": "%b %Y"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Sales ($)",
          "side": "left",
          "type": "linear",
          "format": "$,.0f"
        },
        {
          "id": "y2",
          "title": "Conversion Rate (%)",
          "side": "right",
          "overlaying": "y",
          "type": "linear",
          "format": ".1%"
        }
      ],

      "series": [
        {
          "id": "s1",
          "name": "Sales",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [120000, 150000, 130000],
          "marker": {
            "color": "#4287f5"
          }
        },
        {
          "id": "s2",
          "name": "Conversion Rate",
          "type": "line",
          "y_axis_id": "y2",
          "mode": "lines+markers",
          "data": [0.034, 0.041, 0.038],
          "line": {
            "width": 3
          },
          "marker": {
            "size": 8
          }
        }
      ],

      "annotations": [
        {
          "x": "2024-02",
          "y": 150000,
          "text": "Peak Sales",
          "showarrow": true,
          "arrowhead": 2
        }
      ]
    },

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  },
]

const filteredEventChartDetails = [
  {
    "parent_type": "topic",
    "parent_id": 1,
    "title": "Monthly Sales & Conversion Rate first",
    "description": "Sales performance and conversion trends for Q1.",
    "display_order": 1,

    "data": {
      "type": "mixed",

      "layout": {
        "barmode": "group",
        "showlegend": true,
        "legend": {
          "orientation": "h",
          "x": 0,
          "y": -0.2
        }
      },

      "x_axis": {
        "values": ["2024-Q1", "2024-Q2", "2024-Q3", "2024-Q4"],
        "type": "category",
        "title": "Quarter",
        "format": "%b %Y"
      },

      "y_axes": [
        {
          "id": "y1",
          "title": "Revenue ($)",
          "side": "left",
          "type": "linear",
          "format": "$,.0f"
        },
        {
          "id": "y2",
          "title": "Growth Rate (%)",
          "side": "right",
          "overlaying": "y",
          "type": "linear",
          "format": ".1%"
        }
      ],

      "series": [
        {
          "id": "bar1",
          "name": "Revenue",
          "type": "bar",
          "y_axis_id": "y1",
          "data": [400000, 450000, 470000, 520000],
          "marker": {
            "color": "#4287f5"
          }
        },
        {
          "id": "line1",
          "name": "Growth Rate",
          "type": "line",
          "mode": "lines+markers",
          "y_axis_id": "y2",
          "data": [0.05, 0.07, 0.06, 0.08],
          "line": {
            "width": 3
          },
          "marker": {
            "size": 8
          }
        },
        {
          "id": "area1",
          "name": "Cumulative Revenue",
          "type": "area",
          "y_axis_id": "y1",
          "data": [400000, 850000, 1320000, 1840000],
          "fill": "tozeroy",
          "line": {
            "width": 2
          },
          "marker": {
            "color": "rgba(66,135,245,0.3)"
          }
        }
      ],

      "annotations": [
        {
          "x": "2024-Q4",
          "y": 520000,
          "text": "Highest Quarterly Revenue",
          "showarrow": true,
          "arrowhead": 2
        }
      ]
    }
    ,

    "metadata": {
      "filters_applied": {
        "dimensions": {
          "region": "North America"
        },
        "time_granularity": {
          "granularity": "Monthly",
          "start_date": "2024-01-01",
          "end_date": "2024-03-31"
        }
      },
      "data_quality": {
        "completeness": 0.97,
        "last_updated": "2024-04-05T10:30:00Z"
      }
    }
  }
]

const insights = [
  {parent_id: 1 , insights: ["**Households** purchasing Pro Plan Cat Food grew by **186,721** from **1.84M** to **1.94M** in the last **4 weeks**, indicating a successful strategy in attracting new buyers and expanding brand reach.","**Purchase Frequency** for Pro Plan Cat Food remained stable at **5.0 trips per HH**, suggesting consistent consumer engagement despite the increase in households, which might be driven by effective promotional activities.","**Loyalty** for Pro Plan Cat Food slightly increased from **22.0%** to **22.0%**, reflecting a potential improvement in customer satisfaction or brand affinity as more households are engaging with the brand."]},
  {parent_id: 2 , insights: ["**Households** purchasing Pro Plan Cat Food grew by **186,721** from **1.84M** to **1.94M** in the last **4 weeks**, indicating a successful strategy in attracting new buyers and expanding brand reach.","**Loyalty** for Pro Plan Cat Food slightly increased from **22.0%** to **22.0%**, reflecting a potential improvement in customer satisfaction or brand affinity as more households are engaging with the brand."]},
  {parent_id: 3 , insights: ["**Households** purchasing Pro Plan Cat Food grew by **186,721** from **1.84M** to **1.94M** in the last **4 weeks**, indicating a successful strategy in attracting new buyers and expanding brand reach.","**Purchase Frequency** for Pro Plan Cat Food remained stable at **5.0 trips per HH**, suggesting consistent consumer engagement despite the increase in households, which might be driven by effective promotional activities."]} 
]



export type User = {
  id: string;
  name: string;
  avatar?: string; // optional url or base64
  isYou?: boolean;
};


export const updateUserConfigResponse = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.updateUserConfig, payload); 
    return response;
};

export const getUserChatHistoryResponse = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.chatHistory, payload); 
    return response;
};

export const getAccountInfo = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.accountInfo, payload); 
    return response;
};

export const getUserConversationSummaryResponse = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.conversationSummary, payload); 
    return response;
};

export const getShareUsersList = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.getShareUsers, payload); 
    return response;
};

export const shareChat = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.shareChat, payload); 
    return response;
};

export const getRouterAgentResponse = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.routerAgent, payload); 
    return response;
};

export const deleteUserChat = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.deleteChat, payload); 
    return response;
};

export const renameChatTitle = async (payload: { payload: any }) => {
    const response: any = await client.post(ENDPOINTS.renameChatTitle, payload); 
    return response;
};

/* API's for Insights Hub Page */
// export const getNewsFeedInfo = async () => backendResponse;

export const getNewsFeedInfo = async (params?: { granularity?: string; filter?: string }) => {
  const response: any = await clientInsightshub.get(ENDPOINTS.newsFeedLatest, {
    params,
  });
  console.log("NewsFedd Stauts", response.status)
  return response;
}

// export const getTopicDetails = async () => topicdetails

export const getTopicDetails = async () => {
  const response: any = await clientPerformancePulse.get(ENDPOINTS.topicDetails);
  return response;
}

export const getTopicFilters = async () => filters
export const getEventFilters = async () => filtersEvent

export const getFilters = async (payload: { filtersPayload: { parent_type: string; parent_ids: null; }; }) => {
  const response: any = await clientPerformancePulse.post(ENDPOINTS.getFilters, payload.filtersPayload);
  return response;
  // return filters
}

// export const getMetricDetails = async (payload: { payload: any }) => metricDetails

export const getMetricDetails = async (payload: { payload: unknown[]; }) => {
  console.log("Fetching Metric Details in payload:", payload.payload);
  const response: any = await clientPerformancePulse.post(ENDPOINTS.fetchMetricDetails, payload.payload);
  return response;
  // return metricDetails;
}

// export const getFilteredResponse = async (payload: { payload: any }) => filterMetricDetails

export const getFilteredResponse = async (payload: { filterPayload: any; }) => {
  console.log("Payload in Metric filters", payload.filterPayload);
  const response: any = await clientPerformancePulse.post(ENDPOINTS.fetchMetricDetails, payload.filterPayload);
  return response;
  // return filterMetricDetails;
}

export const getInsights = async (payload: { payload: unknown[]; }) => {
  const response: any = await clientPerformancePulse.post(ENDPOINTS.fetchInsights, payload.payload);
  console.log("Response foInsights",response);
  return response?.data;
}

export const getFilteredInsights = async (payload: { filterPayload: unknown[]; }) => {
  const response: any = await clientPerformancePulse.post(ENDPOINTS.fetchInsights, payload.filterPayload);
  console.log("Response foInsights",response);
  return response?.data;
}

export const getChartDetails = async (payload: { payload: unknown[]; }) => {
  console.log("Payload for getChartDetails", payload.payload);
  const response: any = await clientPerformancePulse.post(ENDPOINTS.fetchChartDetails, payload.payload);
  return response;
  // return chartResponse;
}

export const getFilteredChartDetails = async (payload: { filterPayload: any; }) => {
  console.log("Payload for chart filters", payload.filterPayload);
  const response: any = await clientPerformancePulse.post(ENDPOINTS.fetchChartDetails, payload.filterPayload);
  return response;
  // return filteredChartResponse;
}

export const getLatestDate = async () => {
  const response  = await clientPerformancePulse.get(ENDPOINTS.fetchLatestDate);
  return response;
}

// export const getFiltersEventTracking = async () => filtersEvent

export const getEvents = async () => {
  const response = await clientPerformancePulse.get(ENDPOINTS.eventDetails);
  return response;
}

export const getFiltersEventTracking = async () => {
  const response = await clientPerformancePulse.get(ENDPOINTS.eventDetails);
  return response;
}

export const getEventFilteredResponse = async (payload: { payload: any }) => {
  console.log("Payload in API", payload);
  // const response: any = await clientInsightshub.post(ENDPOINTS.fetchMetricDetails, payload);
  // return response;
  return filterMetricDetails;
}

export const getEventMetricDetails = async (payload: { payload: any }) => {
  console.log("Fetching Event Metric Details in payload:", payload);
  // const response: any = await clientInsightshub.post(ENDPOINTS.fetchMetricDetails, payload);
  // return response;
  return eventMetricDetails;
}

export const getEventChartDetails = async (payload: { payload: any }) => {
  console.log("Payload for getChartDetails", payload);
  // const response: any = await clientInsightshub.post(ENDPOINTS.fetchChartDetails, payload);
  // return response;
  return eventChartDetails;
}

export const getEventFilteredChartDetails = async (payload: { payload: any }) => {
  console.log("Payload for chart filters", payload);
  // const response: any = await clientInsightshub.post(ENDPOINTS.fetchChartDetails, payload);
  // return response;
  return filteredEventChartDetails;
}
